{
  "cancel": "Absagen",
  "save": "Bewahren",
  "manage": "Manage",
  "create": "Anfertigen",
  "delete": "Streichen",
  "new": "Neu",
  "event_nav_title": "Navigation",
  "event_module_name_basic": "Basis",
  "event_module_name_sales": "Verkauf",
  "perc": "%",
  "currency": "€",
  "event_manage": "Veranstaltung Details",
  "event_manage_products": "Produkte",
  "event_manage_status": "Status",
  "event_manage_minimum_age": " Veranstaltung Name",
  "event_manage_minimum_age_info": "Leer lassen  wenn es kein Mindestalter gibt",
  "event_manage_name": " Veranstaltung Name",
  "event_product_title": " Veranstaltung Produkte führen",
  "event_product_saved": "Produkt Details updated!",
  "event_product_add": "Produkt zufügen",
  "product_name": "Produkt Name",
  "product_modal_edit": "Produkt bearbeiten",
  "product_modal_create": "Produkt erstellen",
  "product_saved": "Produkt updated!",
  "product_group": "Gruppe",
  "product_status": "Status",
  "nav_dashboard": "Instrumentenbrett",
  "nav_companies": "Unternehmen managen",
  "nav_events": "Meine Veranstaltungen",
  "nav_company": "Mein Unternehmen",
  "nav_discountcodes": "Rabattcodes",
  "nav_orders": "Bestellungen",
  "nav_reports": "Berichten",
  "nav_administration": "Administratie",
  "nav_extensions": "Erweiterungen",
  "app_logout": "Abmelden",
  "app_impersonating": "Du gibst dich aus als {name}. Klick Abmelden um zu deine eigene Admin Rolle zurückzugehen ",
  "login_email": "E-Mailaddresse",
  "login_password": "Passwort",
  "login_button": "Anmelden",
  "login_error": "Anmelden scheiterte, bitte versuche nochmals ",
  "events_title": " Veranstaltungen managen",
  "event_create": "Neue Veranstaltung anfertigen ",
  "event_new_modal_title": "Ein Ereignis erstellen",
  "event_name": " Veranstaltung Name",
  "event_create_hint": "Nachdem Sie das Ereignis erstellt haben, können Sie bei Bedarf weitere Optionen einstellen.",
  "event_nav_manage": " Veranstaltung Details",
  "event_nav_products": "Produkte/ Tickets",
  "event_nav_pos": "Verkauf Punkten",
  "event_nav_timeslots": "Zeitschlitze",
  "event_manage_title": "Deine Veranstaltung managen: {name}",
  "event_minimum_age": "Mindestalter",
  "event_status": "Status",
  "event_starts_at": "Event fängt an am",
  "event_ends_at": "Event endet am",
  "event_description": " Veranstaltung Umschreibung",
  "company_manage_title": "Managen von Unternehmen {name}",
  "company_users": " Unternehmen Benutzer",
  "company_details": " Unternehmen Details",
  "company_subdomain": "Unterdomäne",
  "company_contact": "Kontaktperson",
  "company_phone": "Telefonnummer ",
  "company_address": "Adresse",
  "company_zip": "Postleitzahl ",
  "company_city": "Stadt",
  "company_kvk": "Industrie- und Handelskammer Nummer",
  "company_vat": "Mw. St. Nummer",
  "company_ticket_fee": "Fee pro Ticket",
  "company_paynl_service_id": "Pay.nl service id",
  "company_country": "Land",
  "company_user_impersonate": "Sich ausgeben als",
  "user_create": "Neuer Benutzer zufügen ",
  "user_language": "Sprache",
  "user_create_modal_title": "Neuer Benutzer zufügen zu {name}",
  "user_name": "Name",
  "user_email": "E-Mail Adresse",
  "user_password": "Passwort",
  "edit_user_modal_title": "Bearbeiten Benutzer Details",
  "user_password_hint": "Dieses Feld leer lassen wenn du das Passwort nicht ändern willst",
  "content_top_welcome_message": "Willkommen bei {whitelabel_layout_name}",
  "event_pos_title": " Veranstaltung Verkauf Punkte ",
  "event_pos_create": "Zufügen",
  "pos_modal_create": "Neuer Verkauf Punkt anfertigen",
  "pos_name": "Name",
  "pos_language": "Sprache",
  "pos_url": "URL",
  "pos_modal_edit": "Ändern Verkauf Punkt",
  "lang_en": "English",
  "lang_nl": "Niederländisch",
  "lang_de": "Deutsch",
  "lang_es": "Spanisch",
  "event_timeslots": "Zeitschlitze",
  "event_timeslot_title": "Deine Zeitschlitze managen: {name}",
  "timeslot_add": "Neuer Zeitschlitz zufügen",
  "timeslot_modal_edit": "Bearbeiten Zeitschlitz ",
  "timeslot_modal_create": "Neuer Zeitschlitz anfertigen",
  "timeslot_interval": "Intervall",
  "timeslot_amount": "Anzahl",
  "interval_hourly": "Pro Stunde",
  "timeslot_start": " Zeitschlitz Start",
  "timeslot_end": " Zeitschlitz Ende",
  "timeslot_starts_at": "Start",
  "timeslot_ends_at": "Ende",
  "timeslot_date": "Datum",
  "timeslot_saved": " Zeitschlitz aufbewahrt!",
  "timeslot_created": " Zeitschlitz angefertigt!",
  "pos_modal_edit_products": "Produkte in Vorrat für diesen Verkauf Punkt",
  "pos_products_hint": "Lasse Vorräte leer wenn du nicht anbieten willst an diesem Verkauf Punkt",
  "pos_payment_methods": "Zahlungsarten",
  "payment_method": "Zahlungsart",
  "pos_open": "Tickets kaufen",
  "pos_event_open": "Öffnen",
  "pos_payment_method_fee_percentage": "Verwaltungskosten (Prozent)",
  "pos_payment_method_fee_fixed": "Verwaltungskosten (Betrag)",
  "pos_updated": "Verkauf Punkt updated!",
  "companies_title": "Unternehmen führen",
  "companies_create": "Neues Unternehmen zufügen",
  "view_pos_minimum_age": "Das Mindestalter für diese Veranstaltung ist {minimum_age}",
  "view_pos_buy": "Jetzt kaufen!",
  "pos_product_sold_out": "Ausverkauft",
  "cart_title": "Bestellungsübersicht",
  "cart_total": "Gesamtbetrag",
  "cart_order": "Weiter",
  "cart_sub_total": "Zwischensumme",
  "cart_ticket_fee": "Verwaltungskosten",
  "cart_empty": "Dein Warenkorb ist derzeit leer, bitte füge ein Produkt hinzu",
  "cart_button_hint": "Sobald du auf die Schaltfläche \"Weiter\" klickst, prüfen wir die Verfügbarkeit und reservieren deine Tickets, während du die Transaktion durchführst.",
  "customer_company_name": "Firmenname",
  "customer_first_name": "Vorname",
  "customer_last_name": "Nachname",
  "customer_address": "Adresse",
  "customer_zip": "Postleitzahl",
  "customer_city": "Stadt",
  "customer_phone": "Telefonnummer",
  "customer_email": "E-Mail Adresse",
  "customer_dob": "Geburtsdatum",
  "customer_gender": "Geschlecht",
  "customer_gender_male": "Männlich",
  "customer_gender_female": "Weiblich",
  "customer_personal_info": "Personal Details",
  "customer_contact_info": "Kontakt Informationen",
  "order_payment_method": "Zahlungsart auswählen",
  "cart_payment_fee": "Zahlungsgebühren",
  "order_continue": "Bestellung aufgeben",
  "payment_bank": "Wähle deinen Bank",
  "payment_loading": "Einen Augenblick Geduld, bitte...",
  "payment_failed": "Zahlung gescheitert!",
  "payment_complete": "Zahlung  erfolgreich! Du wirst deine Bestellungsbestätigung in deinem Inbox empfangen!",
  "event_nav_customer_information": "Kunde Informationen",
  "event_customerinformation_title": "Manage deine Kunde Informationen",
  "question_add": "Eine neue Frage zufügen ",
  "textfield": "Textfeld",
  "select_box": "Dropdown Feld",
  "radio_buttons": "Radio Knöpfen",
  "checkboxes": "Kontrollkästchen",
  "customer_information_modal_create": "Eine Frage zufügen ",
  "customer_information_question": "Was ist deine Frage",
  "customer_information_question_type": "Frage type",
  "customer_information_mandatory": "Verpflichtet",
  "customer_information_where_to_show": "Wo willst du diese Frage stellen",
  "customer_information_show_order": "Bestellung Niveau",
  "customer_information_show_products": "Produkt Niveau",
  "customer_information_modal_edit": "Frage bearbeiten: {question}",
  "customer_information_which_products": "Selektiere das (die) Produkt(e) diesbezüglich welches du die Frage sehen lassen willst",
  "customer_information_new_answer": "Neues Antwort...",
  "customer_information_saved": "Fragen aufbewahrt!",
  "company_name": "Unternehmen Name",
  "first_name": "Vorname ",
  "last_name": "Nachname",
  "address": "Adresse",
  "zip": "Postleitzahl",
  "email": "Email",
  "city": "Stadt",
  "country": "Land",
  "dob": "Geburtsdatum",
  "mobile": "Handy",
  "gender": "Geschlecht",
  "customer_information_title_general_questions": "Allgemeine Fragen nach Bestellung",
  "customer_information_title_specific_questions": "Spezifische Fragen ",
  "dashboard_title": "Willkommen!",
  "pos_not_live": "Dieses Verkauf Punkt ist momentan geschlossen, versuche später nochmals ",
  "order_loading": "Laden deiner Bestellung",
  "event_charge_ticket_fee": "In Rechnung stellen Behandlungsfee pro Ticket zu Kunden ",
  "pos_not_found": "Verkauf Punkt nicht gefunden, bitte kontrolliere deinen Link",
  "order_not_found_or_expired": "Bestellung nicht gefunden oder  verstrichen ",
  "event_continuous": "Diese Veranstaltung ist andauernd ",
  "discountcode_new_modal_title": "Eine neue Rabattcode zufügen ",
  "discountcode_code": " Rabattcode ",
  "discountcode_create_hint": "Wenn du deine Rabattcode angefertigt hast, kannst du mehr detaillierte Informationen feststellen!",
  "discountcode_modal_edit": "Bearbeiten Rabattcode: {code}",
  "discountcode_type": "Type",
  "discountcode_type_percentage": "Prozentsatz",
  "discountcode_type_value": "Wert",
  "discountcode_amount": "Anzahl",
  "discountcode_stock": "Vorrat",
  "discountcode_is_active": "Ist aktiv",
  "discountcode_saved": " Rabattcode aufbewahrt!",
  "discountcode_starts_at": "Fängt an am",
  "discountcode_ends_at": "Endet am",
  "pos_custom_css": "Spezifiziert CSS",
  "order_id": "Bestellung ID",
  "order_full_name": "Kunde Name",
  "order_event": " Veranstaltung ",
  "order_created_at": "Angefertigt am",
  "order_is_paid": "Bezahlt?",
  "order_details": "Details",
  "order_products": "Bestellte Produkte",
  "order_customer_details": "Kunde Details",
  "order_paid": "Bestellung ist bezahlt!",
  "order_not_paid": "Bestellung NICHT bezahlt!",
  "order_total": "Bestellung total",
  "order_payment_created_at": "Angefertigt am",
  "order_payment_status": "Status",
  "order_payment_amount": "Zahlung",
  "nav_scanners": "Scan Bild Center",
  "scanner_add_modal_title": "Ein neuer Scanner zufügen",
  "scanner_name": "Name",
  "scanner_create_hint": "Verwende ein umschreibenden Name für deinen Scanner. Ein Passwort und Anmelden wird automatisch generiert werden ",
  "scanner_show_login_qr": "Zeige Anmelden QR Code",
  "scanner_qr_code": "Scanne diese QR Code auf dem Handy App",
  "close": "Schließen",
  "scanner_edit": "Bearbeitungsscanner",
  "scanner_updated": "Scanner ist updated!",
  "pos_no_group": "Tickets ohne Gruppe ",
  "order_notes": "Notizen",
  "ticket_not_generated": "Ticket nicht generiert!",
  "ticket_generated": "Generiert",
  "ticked_scanned": "Gescannt",
  "ticket_view": "Ticket sehen",
  "ticket_generate": "Neues Ticket generieren",
  "order_create_note": "Neue Notiz anfertigen",
  "order_expires_in": "Wenn du deine Bestellung nicht rechtzeitig ausfüllst, wird sie automatisch annulliert. Du hast noch {timeLeft} um deine Bestellung abzuschließen.",
  "ticket_not_found": "Ticket nicht gefunden",
  "order_no_payment_method": "Keine Zahlungsart selektiert",
  "payment_successful": "Zahlung erfolgreich!",
  "unknown": "Unbekannt",
  "email_order_confirmation": "Bestellungsbestätigung geschickt",
  "audit_show_context": "Details zeigen",
  "email_content": "Email Inhalte",
  "email_ticket_sent": "Ticket geschickt über E-Mail",
  "assign_tickets_title": "Wer bekommt die Tickets?",
  "assign_tickets_hint": "Wir haben deine Bestellung erhalten und deine Zahlung war erfolgreich! Das einzige was noch zu tun ist, ist deine Tickets zuweisen!",
  "assign_tickets_send": "Zuweisen",
  "assign_ticket_self": "Daten selbst ausfüllen",
  "assign_ticket_sent": "Einladung senden",
  "ticket_claim": "Beanspruche Ticket",
  "customer_full_name": "Vollständige Name",
  "customer_form_title": "Deine persönliche Daten",
  "error_try_again": "Es gab ein Fehler, bitte versuche nochmals",
  "error_select_payment_method": "Wähle eine Zahlungsart",
  "product_type": "Produkt Type",
  "product_is_upsell": "Upsell Produkt ohne E-Ticket",
  "product_is_not_upsell": "E-Ticket",
  "product_price": "Preis",
  "product_stock": "Kapazität",
  "product_specific_sale_times": "Spezifische verkauf Zeit",
  "product_no_products": "Keine Produkte sind bisher zugefügt ",
  "discountcode_add_to_cart": "Rabattcode hinzufügen",
  "discount_code_claim": "Bestätigen",
  "discountcode_invalid": "Dieser Rabattcode ist ungültig",
  "cart_discount": "Rabatt {code}",
  "cart_price": "Insgesamt",
  "event_module_name_marketing": "Marketing",
  "event_module_name_organise": "Organisieren",
  "event_print_visitor_list": "Besucherliste",
  "print": "Ausdrücken",
  "order_pick_timeslot": "Wähle Zeitschlitz ",
  "email_ticket_assigned": "E-Mail Ticket zugewiesen",
  "order_actions": "Aktionen",
  "order_cancel": "Bestellung absagen",
  "order_refund": "Bestellung zurückzahlen",
  "order_detail_refund_order_amount": "Anzahlt",
  "order_is_cancelled": "Diese Bestellung ist abgesagt!",
  "order_cancelled": "Bestellung ist abgesagt",
  "order_log": "Log",
  "order_is_refunded": "Bestellung zurückbezahlt",
  "user_added": "Benutzer zugefügt!",
  "company_updated": "Unternehmen Details updated!",
  "user_role": "Rolle",
  "user_updated": " Benutzer Details updated!",
  "login_invalid": "Ungültige Anmeldung, bitte versuche nochmals",
  "no_product_group": "Produkte ohne Gruppe",
  "pos_status": "Status",
  "pos_no_product_category": "Produkte ohne Kategorie",
  "company_invoice_prefix": "Rechnung Präfix",
  "yes": "Ja",
  "no": "Nein",
  "order_number": "Bestellung Nummer",
  "order_resend_confirmation": "Tickets nochmals senden",
  "optin": "Opt-in E-Mail Updates",
  "customer_optin": "Ich möchte aktuelle Informationen über diesen Veranstalter erhalten",
  "customer_optin_iams": "Ja, ich möchte E-Mails von IAMS erhalten, um die Chance zu haben, tolle Preise und VIP-Erlebnisse zu gewinnen",
  "shop_questions_event_hint": "Unser Kundenservice ist immer für dich da. Schreib einfach eine E-Mail oder ruf unter die folgende Tel Nummer an!",
  "shop_questions_tickets_hint": "Bei eventuellen Fragen kannst du immer Fairtix kontaktieren. Schreib einfach eine E-Mail oder ruf unter die folgende Tel Nummer an!",
  "shop_questions_event": "Fragen über die Veranstaltung?",
  "shop_questions_tickets": "Fragen über die Tickets?",
  "order_expired": "Deine Bestellung ist verstrichen, bitte fange aufs Neue an",
  "layout_settings": "Lay-out Rahmen",
  "layout_primary_color": "Haupt Farbe",
  "layout_secondary_color": "Zweite Farbe",
  "layout_secondary_backgroundColor": "Haupt Hintergrund Farbe",
  "layout_colors": "Lay-out Farben",
  "layout_header": "Kopftexte",
  "layout_logo": "Logo",
  "layout_header_backgroundColor": "Kopftexte Hintergrund Farbe",
  "company_layout": "Lay-out ",
  "add": "Füge zu",
  "layout_updated": "Lay-out updated!",
  "shop_tickets": "Tickets",
  "shop_personal_details": "Persönliche Daten",
  "shop_additional_products": "Extra Produkte",
  "shop_timeslot": "Zeitschlitz",
  "shop_pay": "Zahlung",
  "cart_clear": "Warenkorb löschen",
  "invalid_discount_code": "Ungültiger Rabattcode",
  "access_denied": "Zugang verweigert",
  "discountcode_already_exists": "Diese Rabattcode gibt es schon.",
  "end_before_start_date": "End Datum kann nicht bevor Start Datum",
  "scanner_token_invalid": "Token für Scanner ist ungültig",
  "ticket_invalid": "Ticket ist ungültig",
  "ticket_change_owner": "Eigentümer ändern",
  "product_max_exceeded": "Zu viele Produkte in Bestellung, das Anzahl ist oben den Produkt Limit pro Bestellung",
  "order_not_paid_error": "Kann Aktion nicht enden, Bestellung ist nicht bezahlt",
  "product_not_live": "Produkt ist nicht live",
  "product_not_upsell": "Kann Produktbestellung nicht zufügen. Es ist kein zusätzliches Produkt",
  "product_out_of_stock": "Produkt ist nicht in der Vorrat",
  "product_stock_unlimited_icon": "∞",
  "product_stock_unlimited_text": "Unlimited",
  "product_not_unlimited_stock": "product is not unlimited on stock",
  "ticket_already_scanned": "Ticket ist schon gescannt",
  "invalid_ticket_entrance": "Ungültige Eingang für Ticket",
  "timeslot_event_time_mismatch": " Zeitschlitz ist nicht in Veranstaltung Start /End Bereich",
  "timeslot_overlap": "Du kannst keine überlappende Zeiträume anfertigen ",
  "token_expired": "Session verstrichen, bitte anmelden",
  "timeslot_too_many_spots": "Kann keine Zeitschlitz anfertigen: es gibt nicht genug Produkte für dieses Anzahl",
  "assign_tickets_select": "Welche Tickets möchtest du verschicken?",
  "assign_tickets_myself": "Mich selbst zuweisen",
  "assign_tickets_by_invite": "Tickets anderen zuweisen",
  "assign_tickets_continue": "Schicken und weiter",
  "tickets_fill_completed": "Ausgefüllte Tickets",
  "tickets_fill_title": "Deine Tickets vervollständigen ({todo}/{done})",
  "phone": "Telefon Nummer",
  "customer_fields_saved": "Kunde Felde aufbewahrt ",
  "customer_house_nr": "House no",
  "customer_country": "Land",
  "country_de": "Deutschland",
  "country_nl": "Die Niederlande",
  "country_es": "Spanien",
  "country_be": "Belgien",
  "customer_form_custom_questions": "Bitte beantworte die folgende Fragen",
  "errors_please_select": "Bitte wähle eine Option",
  "order_thank_you": "Vielen Dank für deine Bestellung #{order_number}",
  "order_thank_you_text": "Deine Bestellung wurde abgeschlossen.",
  "order_thank_you_btn_ticket_download": "Tickets herunterladen",
  "assign_tickets_next": "Weiter",
  "order_status_number": "Bestellungsübersicht #{order_number}",
  "order_status_event": "Veranstaltung: {name}",
  "order_status_paid": "Bezahlt",
  "order_status_ticket_not_assigned": "Noch nicht registriert",
  "order_status_put_on_name": "Name zuweisen",
  "order_status_product_refunded": "Zurückerstattet am {refunded_at}",
  "order_status_product_cancelled": "Annuliert",
  "order_status_product_invited_at": "Eingeladen am {invited_at}",
  "order_status_ticket_generating": "Ticket wird generiert",
  "order_status_alert_refunded": "Ihre Bestellung wird vollständig erstattet",
  "order_status_alert_cancelled": "Ihre Bestellung wurde storniert",
  "order_status_alert_not_paid": "Ihre Zahlung ist nicht erfolgt oder wurde von unserem Zahlungsdienstleister nicht akzeptiert. Bitte geben Sie eine neue Bestellung auf.",
  "order_status_alert_pending": "Ihre Zahlung ist noch nicht eingegangen. Unser Zahlungsdienstleister wird diese Zahlung manuell überprüfen. Dies kann einige Stunden dauern.",
  "ticket_reminded_at": "Erinnert am",
  "ticket_invited_at": "Eingeladen am",
  "ticket_claimed_at": "Beantragt am",
  "ticket_not_claimed": "Ticket nicht beantragt",
  "ticket_download": "Ticket herunterladen",
  "ticket_send_reminder": "Erinnerung senden",
  "ticket_reminder_sent": "Erinnerung versandt!",
  "customer_email_suggestion": "Du meintest {full}?",
  "order_status_your_tickets": "Deine Tickets",
  "order_open_customer_status": "Offen Kunde Status Seite",
  "ticket_change": "Eigentümer ändern",
  "cart_terms_conditions": "Mit dem Anklicken der Schaltfläche 'Weiter' bestätigen Sie, dass Sie die <a href='{url}' target='_blank'>allgemeinen Geschäftsbedingungen</a> & <a href='https://fairtix.io/de/privacy-policy' target='_blank'>Datenschutzbestimmungen</a> von Fairtix gelesen haben und damit einverstanden sind.",
  "must_agree_with_tos": "Du musst den Allgemeinen Geschäftsbedingungen zustimmen, um fortzufahren.",
  "product_max_buy": "Maximum Ankauf pro Bestellung",
  "product_description": "Beschreibung",
  "actions": "Aktionen",
  "product_vat_percentage": "Mw. St %",
  "product_image": "Bild",
  "template_qr": "QR Code Position",
  "top": "Oben",
  "left": "Links",
  "width": "Breite",
  "height": "Height",
  "template_texts": "Textelemente",
  "template_texts_hint": "Sie können verschiedene Textteile aufstellen",
  "template_add_text": "Textblock zufügen",
  "template_background": "Hintergrund Bild",
  "template_save": "Schablone aufbewahren",
  "generate_preview": "Download Vorschau",
  "nav_ticket_templates": "Ticket Schablone",
  "ticket_template_background": "Ticket Hintergrund",
  "template_background_hint": "Die File die du uploadst sollte 1240x1755 in Pixels, am 72DPI haben",
  "customer_gender_other": "Divers",
  "ticket_template_updated": "Ticket Schablone updated!",
  "template_text_block": "Text",
  "template_position_hints": "Die Seite hat 595 bei 842 'Punkte', alles außer dieser Bereich wird nicht auf dem Ticket gezeigt",
  "ticket_template_name": "Schablone Name",
  "error_name": "Ungültiger Name",
  "event_ticket_template": "Ticket Schablone",
  "event_has_donation_product": "Event can not have more than one Donation product",
  "whatsapp_message": "Bitte beanspruche dein Ticket für {event} hier: {link}",
  "event_updated": " Veranstaltung Details updated!",
  "event_not_live": "Die Veranstaltung ist jetzt nicht offen für Verkauf, versuche später nochmals",
  "event_is_archived": "Die Veranstaltung wurde archiviert und kann nicht mehr bearbeitet werden",
  "event_passed": "Die Veranstaltung ist nicht online",
  "product_sale_starts_at": "Verkauf fängt an am",
  "product_sale_ends_at": "Verkauf endet am",
  "error_page_not_found": "Seite nicht gefunden ",
  "error_is_upsell": "Wähle Deinen Produkt Typ",
  "error_vat_percentage": "Fülle Mw. St. Prozentsatz aus",
  "error_price": "Fülle einen Preis aus",
  "error_stock": "Fülle ein Vorrat Anzahl aus ",
  "error_status": "Wähle ein Status",
  "ticket_confirmation_resent": "Die Tickets wurden erneut verschickt!",
  "view_pos_title": "Produkt-Übersicht für {event_name}",
  "pos_personal_details_title": "Persönliche Daten",
  "pos_timeslot_title": "Zeitschlitz-Übersicht",
  "pos_payment_method_title": "Zahlungsmöglichkeiten",
  "pos_allow_donation_question": "Spenden zulassen?",
  "order_view_order_details_title": "Dein(e) Ticket(s) zuweisen",
  "order_view_assign_title": "Dein(e) Ticket(s) zuweisen",
  "order_thank_you_title": "Danke",
  "order_status_title": "Bestellübersicht",
  "view_pos_cart_title": "Wähle deine Tickets",
  "ticket_customer_not_set": "Kunde nicht gefunden",
  "order_payment_pending": "Sobald deine Zahlung eingegangen ist, senden wir dich eine E-Mail mit einem Link, über den du deine Tickets anfordern kanmst.",
  "order_detail_refund_greater_error": "Anzahl sollte nicht mehr sein als:",
  "order_detail_refund_less_error": "Anzahl sollte positiv sein",
  "order_refund_invalid_amount_error": "Ungültige Anzahl",
  "backend_title_login": "Fairtix Kontrolle Panel",
  "delete_entry": "Bist du sicher du willst streichen?",
  "product_had_been_ordered": "Das Produkt war bestellt",
  "product_modal_delete": "Streich Produkt",
  "product_delete_confirmation": " Bist du sicher du willst streichen?",
  "product_has_been_deleted": "Produkt ist gestrichen",
  "event_event_type": " Veranstaltung Typ",
  "user_role_user": "Benutzer",
  "user_role_company_admin": "Unternehmen Admin",
  "order_detail_payment_method": "Zahlungsart",
  "pos_in_test_mode": "Diese Verkaufsstelle befindet sich im TEST-Modus",
  "order_test_paid": "Test Bestellung",
  "product_successfully_ordered": "Erfolgreich",
  "manage_company_without_vat": "Diese Preise sind ohne Mwst",
  "product_calculate_service_fee": "dem Kunden eine Verwaltungskosten in Rechnung stellen",
  "product_companies_ticket_fee": "Die Ticketgebühr für Ihr Unternehmen beträgt €{ticket_fee_incl} inkl. MwSt.",
  "order_overview_show_expired": "Abgelaufene Bestellungen anzeigen",
  "scan_start_date": "Start",
  "scan_start_time": "Start",
  "scan_end_date": "Ende",
  "scan_end_time": "Ende",
  "scanner_description": "Beschreibung (z.B.: Haupteingang)",
  "scan_operation_session_modal_delete": "Sitzungsbestätigung löschen",
  "scan_operation_session_name": "Name der Sitzung",
  "scan_operation_session_modal_edit": "Sitzungsdetails ändern",
  "scanner_modal_delete": "Scanner entfernen",
  "scanner_username": "Name des Benutzers",
  "scanner_password": "Passwort",
  "session_name": "Name der Sitzung",
  "scanner_modal_edit": "Scanner-Details ändern",
  "next": "Weiter",
  "scan_sessions": "Sitzungen scannen",
  "scan_enable_outgoing_hint": "Besucher beim Verlassen scannen",
  "scan_enable_outgoing": "Ausgehende Scans aktivieren",
  "scan_test_mode_hint": "Einschalten des Testmodus",
  "scan_test_mode": "Test-Modus",
  "scanner_manage_title": "Verwaltung der Scannerdaten",
  "nav_scan_operations": "Scan-Operationen",
  "previous": "Zurück",
  "scan_operation_session_configure_products": "Produkte konfigurieren",
  "sessions": "Sitzungen",
  "scan_operation_products": "Produkte",
  "scan_operation_session_configure_scanners": "Scanners konfigurieren",
  "finish": "Fertig stellen",
  "scan_operation_overview_event": "Veranstaltung: {event_name}",
  "scan_operation_overview_outgoing_scans": "Ausgehende Scans:",
  "scan_operation_overview_outgoing_test_mode": "Test-Modus:",
  "scan_operation_overview_outgoing_enabled": "Aktiviert",
  "scan_operation_overview_outgoing_disabled": "Deaktiviert",
  "scan_operation_overview_outgoing_false": "Falsch",
  "scan_operation_overview_outgoing_true": "Wo",
  "scan_operation_overview_scanners": "Scanners",
  "scan_operation_overview_sessions": "Sitzungen",
  "scan_operation_overview_edit": "Ändern",
  "scan_operation_overview_product_configuration": "Konfiguration des Produkts",
  "scan_operation_overview_scanner_configuration": "Konfiguration des Scanners",
  "scan_operation_overview_for": "Scanvorgang-Übersicht für: {event_name}",
  "backend_title_scan_operation_manage": "Verwalten des Scanvorgangs",
  "backend_title_scan_operation_summary": "Zusammenfassung des Scanvorgangs",
  "backend_title_scan_operation_product_configuration": "Konfiguration des Produkts",
  "backend_title_scan_operation_scanner_configuration": "Konfiguration des Scanners",
  "date_format": "dd.mm.yyyy",
  "export_no_results": "Innerhalb dieses Zeitrahmens werden keine Ergebnisse gefunden",
  "ticket_customer_not_assigned": "Tickethalter nicht zugeordnet",
  "copy_ticket_link": "Link kopieren",
  "ticket_assign": "Ticket zuweisen",
  "ticket_assigned_explenation": "{customer_first_name} hat für Sie ein Ticket für die Veranstaltung {event_name} gekauft. Fordern Sie Ihr Ticket an, indem Sie das folgende Formular ausfüllen.",
  "scan_operation_event": "Veranstaltung",
  "scan_operation_status": "Status",
  "scan_operation_users": "Anzahl von Scannern",
  "scan_operation_actions": "Handlungen",
  "scan_operation_add_modal_title": "Scanvorgang durchführen",
  "select_event": "Veranstaltung",
  "scan_operation_create_hint": "Wählen Sie das Ereignis, für das Sie einen Scanvorgang durchführen möchten",
  "event_module_name_box_offices": "Kassen",
  "event_nav_box_offices": "Kassen",
  "event_box_office_create": "Neue Kasse erstellen",
  "event_box_office_create_name": "Name der Kasse",
  "event_box_office_name": "Kassen",
  "event_box_office_modal_edit": "Kasse bearbeiten",
  "event_box_office_products": "Wählen Sie die in der Kasse angezeigten Produkte aus",
  "event_box_office_payment_methods": "Wählen Sie die angezeigten Zahlungsarten",
  "box_office_updated": "Kasse erfolgreich verändert",
  "event_box_office_check_overrule": "Preisüberschreitung",
  "user_box_office": "Ist die Kasse",
  "box_office_choose_event_title": "Wählen Sie eine Veranstaltung, für die Sie die Abendkasse starten möchten",
  "box_office_choose_box_office_title": "Wählen Sie die Kasse, die Sie für die Veranstaltung starten möchten: {event_name}",
  "box_office_place_order_price": "Preis",
  "box_office_place_order_available": "Verfügbar",
  "box_office_place_order_sold_out": "Ausverkauft",
  "box_office_place_order_save_settings_success": "Erfolgreich",
  "box_office_place_order_customer_details": "Details zum Kunden",
  "box_office_place_order_fill_customer_details": "Füllen Sie die Details des Kunden aus",
  "box_office_place_order_choose_payment": "Wählen Sie die vorgefertigte Zahlungsmethode",
  "box_office_place_order_payment_pin": "Pin",
  "box_office_place_order_payment_cash": "Cash",
  "box_office_place_order_discount_enter": "Enter",
  "box_office_place_order_remove_discount": "Rabatt entfernen",
  "box_office_place_order_empty_cart": "Wagen leeren",
  "box_office_place_order_amount_of_products": "Menge der Produkte:",
  "box_office_place_order_subtotal": "Zwischensumme:",
  "box_office_place_order_total": "Insgesamt:",
  "box_office_place_order_discount": "Rabatt:",
  "box_office_place_order_which_product_to_show": "Welche(s) Produkt(e) möchten Sie zeigen?",
  "box_office_place_order_place_order": "Bestellung aufgeben",
  "event_default_group": "Default Group",
  "event_box_office_use_all_stock": "Verwendung der Bestände an unverkauften Tickets",
  "box_office_place_order_customer_has_to_pay": "Der Kunde muss zahlen",
  "box_office_place_order_given_by_customer_in": "Gegeben durch den Kunden in",
  "box_office_place_order_return_to_customer_in": "Rückgabe an den Kunden in",
  "cart_product": "Produkt",
  "box_office_order_history_order_number": "Bestellnummer",
  "box_office_order_history_order_placed": "Bestellung aufgegeben",
  "box_office_order_history_payment_method": "Zahlungsmethode",
  "box_office_order_history_customer": "Kunde",
  "box_office_order_history_products": "Produkte",
  "box_office_order_history_total_price": "Gesamtpreis",
  "unkown": "Unbekannt",
  "add_discount": "Add discount",
  "box_office_place_save_settings_success": "Gespeicherte Änderungen",
  "order_overview_box_office": "Tageskasse",
  "order_overview_online": "Online",
  "order_type": "Art der Bestellung",
  "box_office_order_history_title": "Geschichte der Bestellung",
  "box_office_place_order_discount_to_high": "Der Rabatt darf den Gesamtbetrag nicht überschreiten",
  "event_show_archived": "Archivierte Ereignisse anzeigen",
  "order_overview_show_box_office_orders": "Bestellungen an der Abendkasse anzeigen",
  "export_to_email": "Export senden an",
  "export_discount": "Rabatt",
  "error_email": "E-Mail ist erforderlich",
  "export_order_success": "Ihr Download wird bald fertig sein, der Link wird an die angegebene E-Mail geschickt.",
  "role_is_required": "Rolle ist erforderlich",
  "password_is_required": "Passwort ist erforderlich",
  "email_is_required": "E-Mail ist erforderlich",
  "username_is_required": "Benutzername ist erforderlich",
  "report_box_office": "Bestellungen an der Abendkasse einbeziehen",
  "report_tickets_sold": "Ausgestellte Tickets",
  "box_office_no_payment_method_chosen": "Keine Zahlungsmethode ausgewählt",
  "box_office_no_products_chosen": "Keine Produkte ausgewählt",
  "product_remove_image": "Bild entfernen",
  "order_details_edit_customer_data": "Kundendaten bearbeiten",
  "order_details_edit_customer_success_message": "Kundendaten werden aktualisiert",
  "customer_already_exists": "Kunde existiert bereits",
  "scan_operation_show_archived": "Archivierten Scanvorgang anzeigen",
  "no_results_have_been_found": "Es wurden keine Ergebnisse gefunden",
  "error_ticket_template_id": "Ticketvorlage wurde nicht ausgewählt",
  "test_payment": "Test Zahlung",
  "layout_top_bar_date_color": "Textfarbe des Datums",
  "layout_stepper_hint_color": "Farbe des Hinweistextes",
  "order_ticket_scanned_at": "Gescannt am",
  "order_ticket_not_yet_scanned": "Noch nicht gescannt",
  "pos_product_expired": "Abgelaufen",
  "product_min_buy": "Mindestabnahme pro Auftrag",
  "product_amount_is_less_than_minimum_amount": "Die Produktmenge liegt unter der Mindestmenge",
  "min_buy_should_be_less_than_max_buy": "Der Mindestkauf sollte geringer sein als der Höchstkauf",
  "product_multi_day_ticket": "Mehrtageskarte",
  "order_detail_modal_cancel_order_title": "Bestellung absagen: #{order}",
  "order_detail_modal_refund_order_title": "Bestellung zurückzahlen: #{order}",
  "order_detail_modal_resent_tickets_title": "Tickets nochmals senden: #{order}",
  "order_detail_resent_tickets_confirmation": "Sind Sie sicher, dass Sie die Tickets erneut versenden möchten?",
  "order_detail_resent_confirmation_tickets": "Tickets schicken",
  "dashboard_events_tickets_sold": "Tickets inklusive {guest_list_number} Gästeliste",
  "dashboard_events_today": "Heute",
  "dashboard_events_last_7_days": "Letzte 7 Tage",
  "dashboard_events_total_revenue": "Gesamtumsatz:",
  "duplicate": "Duplizieren Sie",
  "event_duplicate_event": "Ereignis duplizieren",
  "event_new_name": "Neuer Ereignisname",
  "event_duplicate_choose_products_to_copy": "Wählen Sie, welche(s) Produkt(e) Sie kopieren möchten",
  "event_duplicate_point_of_sales": "URLs der Verkaufsstellen",
  "select_all": "Alle auswählen",
  "unselect_all": "Alle abwählen",
  "event_scan_operation_session_date_to_change": "Datum und Uhrzeit des Scanvorgangs müssen geändert werden",
  "event_name_has_to_be_changed": "Der Ereignisname muss geändert werden",
  "customer_support_free_search": "Freie Suche",
  "customer_support_search": "Suche",
  "customer_support_reset_filter": "Filter zurücksetzen",
  "customer_support_filters": "Filter",
  "customer_support_company": "Unternehmen:",
  "customer_support_event": "Veranstaltung:",
  "customer_support_payment_status": "Zahlungsstatus:",
  "customer_support_center": "Kunden-Support-Center",
  "order_status_new": "Neu",
  "order_status_pending": "Anhängig",
  "user_role_customer_support": "Kundenbetreuung",
  "no_data_to_show": "Keine Daten zum Nachweis",
  "submit": "Submit",
  "pos_show_in_overview": "Verkaufsstelle in der Veranstaltungsübersicht anzeigen",
  "login_username": "Benutzername",
  "scan_operation_terminal_button": "Scan-Terminal",
  "scanner_terminal_event": "Scan terminal für",
  "dashboard_events_scans": "Scans:",
  "dashboard_total_visitors_inside": "Besucher innen",
  "dashboard_scanned": "Gescannt",
  "dashboard_left_to_scan": "Zu scannen",
  "dashboard_box_office_entries": "Kasseneinträge",
  "opening_hours_hourly": "stündlich",
  "opening_hours_all_day": "den ganzen Tag",
  "opening_hours_create": "Offene Stunde hinzufügen",
  "opening_hours_day_of_week": "Tag",
  "opening_hours_opens_at": "öffnet sich von",
  "opening_hours_closes_at": "schließt sich an",
  "opening_hours_spots": "Spots",
  "opening_hour_interval": "Intervall",
  "opening_hour_create": "Neu",
  "edit_opening_hours_day": "Öffnungszeiten für den Tag ändern",
  "opening_hours_adjust": "Tag ändern",
  "day_adjusted": "Geänderte Öffnungszeiten für den Tag",
  "event_timeslots_actions": "Actions",
  "error_opens_at": "Öffnet bei wird nicht korrekt ausgefüllt",
  "error_closes_at": "Schließt bei nicht korrekt ausgefüllt ist",
  "error_spots": "Die Plätze sind nicht besetzt",
  "error_interval": "Intervall wird nicht gewählt",
  "order_pick_date": "Wählen Sie Ihr Datum",
  "order_timeslot": "Zeitfenster",
  "invalid_opening_hour": "Ungültige Öffnungszeit",
  "event_ticket_template_product_tooltip": "Die Auswahl einer Vorlage setzt die für die Veranstaltung konfigurierte Standard-Ticketvorlage für dieses spezifische Produkt außer Kraft.",
  "company_show_kvk_on_pos": "Handelskammernummer im Shop anzeigen",
  "shop_chamber_of_commerce_number": "Handelskammernummer",
  "my_company_invoice_title": "Automatische Rechnungseinstellungen",
  "my_company_invoice_automatic_invoicing": "Automatische Rechnungsstellung aktivieren",
  "my_company_invoice_automatic_invoicing_test_mode": "Testmodus (keine Auszahlungen)",
  "my_company_invoice_vat_shifted": "Rechnungen umsatzsteuerlich verlagern",
  "my_company_invoice_anti_dating": "Anti-Datum Pay.nl Auszahlungen",
  "my_company_invoice_include_payout_summary": "Auszahlungsübersichtsbericht einbeziehen",
  "my_company_invoice_include_fairtix_invoice": "Fairtix-Rechnung für Kunden beifügen",
  "my_company_invoice_generate_fairtix_invoice": "Erzeugen einer Fairtix-Rechnung für den Kunden",
  "my_company_invoice_include_detailed_explanation": "Detaillierten zusammenfassenden Bericht einschließen",
  "my_company_invoice_generate_detailed_explanation": "Detaillierten zusammenfassenden Bericht generieren",
  "my_company_invoice_set_off_invoices": "Verrechnung der Auszahlungsrechnung mit der Fairtix-Rechnung",
  "my_company_invoice_generate_payout_summary": "Auszahlungsübersichtsbericht erstellen",
  "my_company_invoice_payout_frequency": "Häufigkeit der Auszahlung",
  "my_company_invoice_max_payment_period": "Maximale Zahlungsfrist (in Tagen)",
  "my_company_invoice_payout_delay": "Verzögerung der Auszahlung nach dem Ereignis (in Tagen)",
  "my_company_invoice_receive_method": "Empfangsmethode",
  "backend_title_events_visitor_list": "Besucherliste der Veranstaltung",
  "event_deleted": "Veranstaltung gelöscht!",
  "event_has_orders": "Veranstaltung hat Bestellungen",
  "pos_overview_read_less": "Weniger lesen",
  "pos_overview_read_more": "Mehr lesen",
  "manage_event_image": "Bild (530x340 Pixel)",
  "manage_event_remove_image": "Bild entfernen",
  "manage_event_image_tooltip": "Dieses Bild wird in der Ereignisübersicht angezeigt",
  "pos_sale_ends_in_days_and_hours": "Verkauf endet in {days} Tag(e) und {hours} Stunde(n)",
  "pos_sale_ended_at": "Verkauf endet am",
  "pos_sale_ends_in_hours": "Der Verkauf endet in {hours} Stunden",
  "ticket_claim_copy_order_data": "Persönliche Daten aus der Bestellung kopieren",
  "template_background_jpg_hint": "Nur JPGs dürfen hochgeladen werden",
  "company_settings": "Einstellungen",
  "company_send_order_notifications": "Auftragsbenachrichtigungen senden",
  "company_send_order_notifications_email": "E-Mail-Adresse, die Benachrichtigungen erhalten soll",
  "reports_include_archived_events": "Archivierte Veranstaltungen einbeziehen",
  "pos_sale_ends_in_minutes": "Der Verkauf endet in {minutes} Minute(n)",
  "pos_sale_ends_in_months_days_and_hours": "Der Verkauf endet in {months} Monat(en), {days} Tag(e) und {hours} Stunde(n)",
  "pos_sale_ends_in_months_days": "Verkauf endet in {months} Monat(en) und {days} Tag(e)",
  "pos_sale_ends_in_months": "Verkauf endet in {months} Monat(en)",
  "dashboard_sold_tickets": "Verkaufte Tickets für: {event}",
  "add_attendees": "Teilnehmer hinzufügen",
  "guest_list_add_attendees": "Gästeliste Tickets versenden",
  "guest_list_choose_tickets": "Wählen Sie das/die Ticket(s)",
  "guest_list_total_worth": "Gesamtwert:",
  "guest_list_total_items": "Posten insgesamt:",
  "guest_list_order_data": "Daten bestellen",
  "quest_list_populate_tickets_with_customer_data": "Tickets mit Kundendaten bestücken",
  "guest_list_todo_next_send_invite_to_claim_tickets": "Einladung senden, um Tickets zu beantragen",
  "guest_list_todo_next_send_invite_to_claim_tickets_description": "Der Inhaber der Bestellung erhält eine E-Mail mit einem Link, über den alle Tickets zugewiesen und angefordert werden können",
  "guest_list_todo_next_send_all_tickets_to_order_owner": "Senden Sie alle Tickets an den Besitzer der Bestellung",
  "guest_list_todo_next_send_all_tickets_to_order_owner_description": "Der Inhaber der Bestellung erhält eine E-Mail, in der alle Tickets als separate PDFs angehängt sind.",
  "guest_list_todo_next_place_order_without_sending_tickets": "Bestellung ohne Ticketversand aufgeben",
  "guest_list_todo_next_place_order_without_sending_tickets_description": "Die Bestellung wird ohne Zusendung von Tickets aufgegeben",
  "guest_list_no_payment_needed": "Keine Zahlung erforderlich",
  "guest_list_paid_with_cash": "Bezahlt mit Bargeld",
  "guest_list_send_order_confirmation": "Auftragsbestätigung per E-Mail senden",
  "guest_list_order_saved_successfully": "Tickets erfolgreich hinzugefügt",
  "guest_list_order_saved_successfully_desc": "Der Auftrag wurde erstellt und die Tickets wurden ihm zugefügt. Die angegebene Person hat eine E-Mail mit den Details erhalten.",
  "guest_list_not_all_customer_details_filled": "Nicht alle Kundendaten wurden ausgefüllt",
  "order_overview_free_tickets": "Freie Bestellung",
  "order_overview_manual_orders": "Manuelle Bestellung",
  "place_order_without_tickets": "Bestellung ohne Ticketversand aufgegeben",
  "guest_list_tickets_claim_invite": "Einladung zur Ticketausstellung verschickt",
  "guest_list_payment_terms": "Was möchten Sie mit der Zahlung tun?",
  "guest_list_what_next": "Was möchten Sie als nächstes tun?",
  "guest_list_order_confirmation_with_tickets_and_payment": "Versand der Auftragsbestätigung für hinzugefügte Kunden",
  "guest_list_order_confirmation_with_tickets": "Versand der Auftragsbestätigung für hinzugefügte Kunden",
  "guest_list_order_confirmation_with_payment": "Versand der Auftragsbestätigung für hinzugefügte Kunden",
  "guest_list_order_confirmation": "Versand der Auftragsbestätigung für hinzugefügte Kunden",
  "multi_tickets_created": "Die Tickets wurden verschickt",
  "guest_list_send_all_tickets_to_order_owner": "Die Tickets wurden an den Inhaber der Bestellung gesendet",
  "guest_list_todo_next_send_payment_link": "Zahlungslink senden",
  "guest_list_todo_next_send_payment_link_description": "Der Empfänger erhält eine E-Mail mit einem Link zum Bezahlen. Sobald die Zahlung eingegangen ist, werden die Tickets verschickt.",
  "guest_list_send_tickets_to_ticket_holders": "Das Ticket wurde direkt an einen Ticketinhaber geschickt",
  "ticket_created": "Ticket wurde gesendet",
  "event_name_64_char": "Der Ereignisname darf nicht kürzer als 4 Zeichen und nicht länger als 64 Zeichen sein.",
  "report_orders_grouped_by_tickets": "Bestellungen gruppiert nach Anzahl der Tickets",
  "report_tickets_per_order": "Tickets pro Bestellung",
  "report_number_of_orders": "Anzahl der Bestellungen",
  "report_order_placed": "Erteilte Bestellung",
  "report_ticket_type": "Ticket-Typ",
  "report_tickets_selected": "Ticket(s) ausgewählt",
  "report_select_ticket": "Ticket auswählen",
  "report_sales_per_day": "Verkäufe pro Tag",
  "report_sales_per_day_cumulative": "Verkäufe kumuliert",
  "ticket_is_required": "Das Feld Tickets ist erforderlich",
  "reset_password": "Setzen Sie Ihr Passwort zurück",
  "password_reset_successfully": "Passwort wurde erfolgreich gesetzt",
  "password_confirmation": "Passwort bestätigen",
  "company_user_reset_password_checkbox": "Passwort beim Login zurücksetzen lassen",
  "password_not_match": "Passwort stimmt nicht mit Bestätigungspasswort überein",
  "password_reset_user_should_reset_password": "Sie sollten das Passwort zurücksetzen",
  "ticket_secret": "Ticket-Geheimnis",
  "scanner_terminal_showing_of_entries": "Zeigt {per_page} von {total} Einträgen",
  "scanner_terminal_search": "Suche",
  "scanner_terminal_filter_btn": "Filter",
  "scanner_terminal_btn_check_in": "Einchecken",
  "ticket_unclaimed_reminding": "Erinnerung an die Kartenabholung",
  "order_refund_choose_which_products_to_refund": "Wählen Sie die Produkt(e), die Sie erstatten möchten",
  "order_refund_include_ticket_fees": "Ticket-Verwaltungskosten in Höhe von {total} in die Erstattung einbeziehen",
  "order_refund_include_payment_fees": "Einbeziehung der Kosten für die Zahlungsverwaltung in Höhe von {total} in die Erstattung",
  "order_refund_total_amount": "Zu erstattender Gesamtbetrag:",
  "order_refund_total_bigger_paid": "Der zu erstattende Gesamtbetrag darf nie höher sein als der gezahlte Gesamtbetrag",
  "could_not_process_payment": "Zahlung konnte nicht verarbeitet werden",
  "company_refund_fee": "Gebühr pro Erstattung",
  "nav_master_data": "Stammdaten",
  "roles_roles_permissions": "Rollenberechtigungen",
  "roles_permission_roles": "Berechtigung Rollen",
  "roles_name": "Name",
  "roles_admin_only": "Nur Administrator",
  "roles_online": "Online",
  "roles_created_by": "Erstellt von",
  "role_saved_successfully": "Rolle erfolgreich gespeichert",
  "role_deleted_successfully": "Rolle erfolgreich gelöscht",
  "company_permissions": "Unternehmen Berechtigungen",
  "company_user_settings_tab": "Benutzereinstellungen",
  "company_permissions_tab": "Berechtigungen",
  "not_have_permission": "Sie haben keine Berechtigung für den Zugriff auf diese Seite",
  "permission_order_overview_view": "Ansicht Auftragsübersicht",
  "permission_stock_report_view": "Ansicht Bestandsbericht",
  "permission_admin_company_overview_view": "Verwaltung Firmenübersicht",
  "permission_admin_company_payment_costs_view": "Ansicht der Zahlungskosten der Verwaltungsgesellschaft",
  "permission_admin_company_payment_costs_edit": "Zahlungskosten der Verwaltungsfirma bearbeiten",
  "permission_admin_company_payment_costs_create": "Zahlungskosten der Verwaltungsfirma hinzufügen",
  "permission_admin_company_user_impersonate": "Verwaltende Firma Benutzer verkörpern",
  "permission_admin_company_details_view": "Verwalten der Firmendetails Ansicht",
  "permission_admin_company_details_edit": "Admin Firmen Details bearbeiten",
  "permission_order_overview_export": "Auftragsübersicht exportieren",
  "permission_order_overview_search": "Bestellübersicht suchen",
  "permission_order_detail_view": "Detailansicht der Bestellung",
  "permission_order_cancel": "Bestellung stornieren",
  "permission_order_refund": "Bestellung erstatten",
  "permission_order_order_confirmation": "Bestellung Auftragsbestätigung",
  "permission_order_detail_product_cancel": "Bestellungsdetail Produkt stornieren",
  "permission_order_detail_product_change_owner": "Bestellungsdetail Produkt Besitzer ändern",
  "permission_order_detail_change_customer_details": "Bestellungsdetail Kundendaten ändern",
  "permission_add_attendees_view": "Ansicht Teilnehmer hinzufügen",
  "permission_event_overview_view": "Ansicht Veranstaltungsübersicht",
  "permission_event_create": "Veranstaltung erstellen",
  "permission_event_delete": "Veranstaltung löschen",
  "permission_event_duplicate": "Veranstaltung duplizieren",
  "permission_event_details_view": "Ansicht Veranstaltungsdetails",
  "permission_event_details_edit": "Ereignisdetails bearbeiten",
  "permission_event_products_view": "Ereignis Produkte anzeigen",
  "permission_event_products_edit": "Ereignisprodukte bearbeiten",
  "permission_event_products_delete": "Ereignisprodukte löschen",
  "permission_event_products_create": "Ereignisprodukte erstellen",
  "permission_event_timeslot_view": "Ereignis Zeitfenster Ansicht",
  "permission_event_customer_information_view": "Ereignis Kundeninformationen anzeigen",
  "permission_event_customer_information_edit": "Veranstaltung Kundeninformationen bearbeiten",
  "permission_event_point_of_sale_view": "Ereignis Verkaufsstelle Ansicht",
  "permission_event_point_of_sale_create": "Ereignis Verkaufsstelle erstellen",
  "permission_event_point_of_sale_edit": "Ereignis Verkaufsstelle bearbeiten",
  "permission_reports_view": "Berichte Ansicht",
  "permission_reports_sales_by_tickettype_view": "Berichte Verkauf nach Tickettyp Ansicht",
  "permission_discountcode_view": "Rabattcode-Ansicht",
  "permission_discountcode_create": "Rabattcode erstellen",
  "permission_discountcode_edit": "Rabattcode bearbeiten",
  "permission_scan_operation_view": "Ansicht Scanvorgang",
  "permission_scan_operation_create": "Scanvorgang erstellen",
  "permission_scan_operation_edit": "Scanvorgang bearbeiten",
  "permission_ticket_template_view": "Ticketvorlage anzeigen",
  "permission_ticket_template_create": "Ticketvorlage erstellen",
  "permission_ticket_template_edit": "Ticketvorlage bearbeiten",
  "permission_my_company_view": "Ansicht Mein Unternehmen",
  "permission_my_company_user_create": "Benutzer meiner Firma erstellen",
  "permission_my_company_user_edit": "Benutzer meiner Firma bearbeiten",
  "permission_my_company_user_delete": "Benutzer meiner Firma löschen",
  "permission_my_company_layout_view": "Mein Firmenlayout anzeigen",
  "permission_my_company_layout_edit": "Mein Firmenlayout bearbeiten",
  "permission_dashboard_view": "Dashboard-Ansicht",
  "permission_customer_support_view": "Ansicht Kundensupport",
  "permission_admin_company_permission_view": "Ansicht der Verwaltungsberechtigung für Unternehmen",
  "permission_admin_company_permission_edit": "Admin-Unternehmensberechtigung bearbeiten",
  "permission_my_company_user_permissions_view": "Ansicht der Benutzerrechte für mein Unternehmen",
  "permission_my_company_user_permissions_edit": "Benutzerberechtigungen für mein Unternehmen bearbeiten",
  "permission_master_data_view": "Ansicht Stammdaten",
  "permission_master_data_permissions_roles_view": "Stammdaten Berechtigungen Rollen Ansicht",
  "permission_master_data_permissions_roles_edit": "Stammdatenberechtigungen Rollen bearbeiten",
  "permission_admin_automatic_invoicing_view": "Ansicht Automatische Rechnungsstellung für Administratoren",
  "permission_no_company_privileges": "Es wurden keine Firmenprivilegien festgelegt",
  "user_allowed_events": "Bestimmte Ereignisse auswählen, die der Benutzer sehen kann",
  "permission_my_company_user_box_office_edit": "Mein Unternehmen kann Kasse machen",
  "permission_role_templates": "Rollenvorlagen",
  "permission_events_selected": "Ereignis(e) ausgewählt",
  "permission_all_events": "Alle Veranstaltungen",
  "search": "Suche",
  "permission_master_data_permission_roles_create": "Stammdaten-Berechtigungsrollen erstellen",
  "permission_master_data_permissions_roles_delete": "Stammdaten-Berechtigungsrollen löschen",
  "permission_admin_company_add_company": "Admin Firma kann Firma hinzufügen",
  "permission_admin_company_automatic_invoicing_edit": "Admin automatische Rechnungsstellung bearbeiten",
  "permission_admin_company_users_view": "Ansicht der Firmenbenutzer verwalten",
  "permission_admin_company_users_edit": "Verwaltende Benutzer der Firma bearbeiten",
  "permission_admin_company_users_delete": "Verwaltende Benutzer des Unternehmens löschen",
  "permission_order_detail_payment_history_view": "Bestellungsdetail Zahlungshistorie anzeigen",
  "permission_order_detail_notes_view": "Ansicht Bestellungsdetail Notizen",
  "permission_order_detail_notes_create": "Bestellungsdetail Notizen erstellen",
  "permission_order_detail_log_view": "Ansicht Bestellungsdetailprotokoll",
  "permission_my_company_users_view": "Ansicht der Benutzer meiner Firma",
  "permission_event_visitor_list_view": "Ansicht der Veranstaltungsbesucherliste",
  "Ereignis_erstellt": "Ereignis wurde erstellt",
  "scan_operation_created": "Scanvorgang wurde erstellt",
  "ticket_template_created": "Ticketvorlage wurde erstellt",
  "permission_my_company_settings_edit": "Einstellungen meines Unternehmens bearbeiten",
  "permission_my_company_settings_view": "Meine Firmeneinstellungen anzeigen",
  "permission_scan_terminal_view": "Ansicht des Scan-Terminals",
  "permission_admin_company_details_page_view": "Ansicht der Verwaltungsseite für Unternehmensdetails",
  "event_duplicated": "Ereignis wurde dupliziert",
  "admin_company_payment_costs_create": "Zahlungsmethode hinzufügen",
  "admin_company_add_payment_method": "Zahlungsmethode hinzufügen",
  "admin_company_payment_method": "Zahlungsmethode",
  "admin_company_payment_method_fee_percentage": "Gebühr in Prozent",
  "admin_company_payment_method_fee_fixed": "Feste Gebühr",
  "admin_company_payment_method_start_at": "Gültig ab",
  "error_fee_fixed_amount": "Fixed fee ist verpflichtet",
  "error_fee_percentage": "Fee percentage ist verpflichtet",
  "admin_company_payment_method_added": "Zahlungsart hinzugefügt",
  "my_company_layout_remove_image": "Bild entfernen",
  "my_company_invoice_language": "In welcher Sprache sollte die Rechnung verfasst werden?",
  "permission_discountcode_delete": "Rabattcode löschen",
  "discountcode_deleted": "Rabattcode gelöscht",
  "discountcode_is_used": "Der Rabattcode wurde bereits verwendet und kann daher nicht entfernt werden",
  "order_details_change_order_event": "Bestellung auf anderes Ereignis umstellen",
  "order_details_event_changed_message": "Das Auftragsereignis wurde erfolgreich umgestellt.",
  "permission_order_detail_change_event": "Auftragsdetails ändern Ereignis",
  "pos_payment_method_not_exists": "Zahlungsmethode an der Verkaufsstelle nicht vorhanden",
  "order_details_change_event_modal_products_title": "Wählen Sie die neuen Produkte",
  "order_details_change_event_modal_event": "Wählen Sie das Ereignis, zu dem Sie die Reihenfolge ändern möchten",
  "order_details_change_event_modal_pos": "Wählen Sie die Verkaufsstelle, zu der Sie den Auftrag umleiten möchten",
  "permission_admin_company_fee_view": "Verwaltungsgebühr für Unternehmen anzeigen",
  "permission_admin_company_fee_edit": "Verwaltungsgebühr für Unternehmen bearbeiten",
  "permission_admin_company_fee_add": "Verwaltungsgebühr für Unternehmen hinzufügen",
  "admin_company_add_company_fee": "Unternehmensgebühr hinzufügen",
  "admin_company_fee_type": "Art der Gebühr",
  "admin_company_fee": "Gebühr",
  "admin_company_fee_start_at": "Beginnt bei",
  "admin_company_company_fee_updated": "Unternehmensgebühr aktualisiert",
  "admin_company_company_fee_added": "Unternehmensgebühr hinzugefügt",
  "admin_company_company_fee_ticket_fee": "Ticket-Gebühr",
  "admin_company_company_fee_box_office_ticket_fee": "Kartengebühr an der Abendkasse",
  "admin_company_company_fee_refund_fee": "Erstattungsgebühr",
  "admin_company_company_fee_free_tickets_free_percentage": "Prozentsatz der Freikarten",
  "admin_company_company_fee_free_ticketfee": "Gebühr für Freikarten",
  "update": "Aktualisierung",
  "administration_overview_invoice": "Übersicht der Rechnungen",
  "backend_title_invoices_overview": "Übersicht der Rechnungen",
  "permission_admin_administration_view": "Ansicht Verwaltung",
  "permission_invoice_details_view": "Rechnungsdetails anzeigen",
  "permission_invoice_overview_search": "Suche in der Rechnungsübersicht",
  "permission_invoice_overview_view": "Rechnungsübersicht ansehen",
  "permission_order_detail_generate_ticket": "Auftragsdetail generiert neues Ticket",
  "permission_invoice_details_create_credit_invoice": "Rechnungsdetails Kreditrechnung erstellen",
  "invoice_details_create_credit_invoice": "Gutschriftrechnung erstellen",
  "permission_mgmt_app_login": "Kann sich anmelden",
  "permission_mgmt_app_event_submenu_checkin_view": "Check-in Übersicht",
  "permission_mgmt_app_event_scan_total_tickets_scanned_view": "Anzeige der insgesamt gescannten Tickets auf dem Scannerbildschirm",
  "permission_mgmt_app_event_checkin_swipe_checkout": "Einchecken durchziehen unscannen",
  "permission_mgmt_app_ticket_detail_view": "Kann Ticketdetails sehen",
  "permission_mgmt_app_event_dashboard_tickets_sold_view": "Dashboard Übersicht verkaufter Tickets",
  "permission_mgmt_app_event_scan_ticket_details_view": "Ticketdetails nach dem Scannen anzeigen",
  "permission_mgmt_app_prices_view": "Preise anzeigen",
  "permission_mgmt_app_event_overview_active_events": "Aktive Veranstaltungen anzeigen",
  "permission_mgmt_app_event_overview_past_events": "Vergangene Veranstaltungen anzeigen",
  "permission_mgmt_app_menu_search_in_all_orders_view": "Suche in allen Bestellungen",
  "permission_mgmt_app_menu_device_settings_view": "Menü Geräteeinstellungen",
  "permission_mgmt_app_menu_event_overview_view": "Menü Veranstaltung übersicht",
  "permission_mgmt_app_event_dashboard_tickets_scanned_view": "Übersicht der gescannten Tickets im Dashboard",
  "permission_mgmt_app_event_submenu_dashboard_view": "Übersicht über das Dashboard",
  "permission_mgmt_app_event_submenu_home_view": "Überblick über die Veranstaltung",
  "permission_mgmt_app_event_submenu_orders_view": "Übersicht bestellen",
  "permission_mgmt_app_event_checkin_swipe_checkin": "Einchecken mit Durchzug",
  "permission_mgmt_app_event_checkin_scan_btn_view": "Check-in-Scan-Taste anzeigen",
  "permission_mgmt_app_ticket_detail_btn_checkin": "Ticket-Detail-Checkin",
  "permission_mgmt_app_ticket_detail_btn_checkout": "Ticket-Details unscannen",
  "permission_mgmt_app_event_checkin_product_settings_view": "Übersicht über die spezifischen Produkteinstellungen beim Einchecken",
  "permission_mgmt_app_event_checkin_product_settings_update": "Kann konfigurieren, welche Produkte gescannt werden sollen",
  "permission_mgmt_app_ticket_sales_view": "Kann den Kartenverkauf einsehen",
  "administration_invoice_number": "Rechnungsnummer",
  "permission_administration_overrule_fees_per_event_view": "Verwaltungsgebühren für Overrule pro Veranstaltung",
  "permission_administration_overrule_fees_per_event_edit": "Verwaltungsgebühren pro Veranstaltung bearbeiten",
  "administration_event_fees": "Überstreichungsgebühr für Veranstaltung",
  "event_fees_retroactive": "Rückwirkend",
  "edit": "Bearbeiten",
  "company": "Unternehmen",
  "permission_mgmt_app_user_device_settings_view": "Einstellungen des Benutzergeräts anzeigen",
  "permission_mgmt_app_user_device_settings_update": "Einstellungen des Benutzergeräts aktualisieren",
  "pos_terms_conditions_url": "Allgemeinen Geschäftsbedingungen url",
  "cart_terms_conditions2": "Mit dem Anklicken der Schaltfläche 'Weiter' bestätigen Sie, dass Sie die <a href='{url}' target='_blank'>allgemeinen Geschäftsbedingungen</a> & <a href='https://fairtix.io/de/privacy-policy' target='_blank'>Datenschutzbestimmungen</a> von Fairtix und die <a href='{url2}' target='_blank'>allgemeinen Geschäftsbedingungen</a> von {name} gelesen haben und damit einverstanden sind.",
  "pos_invalid_url": "Ungültige URL",
  "company_tickets_sold_out_notification": "Benachrichtigung bei fast ausverkauftem Haus senden",
  "report_days_before_event": "{days} Tage vor Event",
  "report_event_day": "Datum des Event",
  "report_days_from_event": "{days} Tage ab Event",
  "report_free_tickets": "davon Freikarten",
  "reports_scans_by_type": "Scans nach Typ",
  "reports_tickets_scans": "Fahrkarten-Scans",
  "reports_tickets_scans_hourly": "Stündlich",
  "reports_tickets_scans_daily": "Täglich",
  "reports_tickets_scans_weekly": "Wöchentlich",
  "reports_tickets_scans_monthly": "Monatlich",
  "reports_period": "Periode",
  "reports_time_from": "Zeit von",
  "reports_time_to": "Zeit bis",
  "reports_tickets_scanned": "Tickets gescannt",
  "company_layout_logo_url": "Logo URL",
  "pos_stock_pos": "POS",
  "pos_stock_product": "Produkt",
  "pos_stock_product_stock": "Produktbestand",
  "pos_stock_in_redis": "In redis",
  "pos_stock_pos_stock": "POS-Bestand",
  "pos_stock_sold": "Verkauft",
  "email_confirmation": "E-Mail bestätigen",
  "customer_form_email_confirmation_not_match": "Emails stimmen nicht überein",
  "report_in_worth_of": "Im Wert von",
  "order_already_paid": "Bestellung bereits bezahlt!",
  "customer_form_click_on_claim_button": "Klicken Sie auf die Schaltfläche Beanspruche Ticket, um das Ticket an Ihre E-Mail Adresse zu senden",
  "pos_no_language": "Keine Sprache ausgewählt",
  "customer_information_specific_tickets": "Stellen Sie diese Frage nur, wenn die Bestellung bestimmte Tickets enthält",
  "scan_terminal_choose_event_title": "Wählen Sie ein Ereignis, für das Sie das Scan-Terminal starten möchten",
  "permission_scan_terminal_login": "Anmeldung zum Scan-Terminal",
  "permission_scan_terminal_ticket_overview": "Scan-Terminal Tickets Übersicht",
  "no_scan_operation": "Es gibt keinen Scanvorgang für das Ereignis",
  "no_events_to_show": "Keine Ereignisse zu zeigen",
  "customer_information_field": "Feld",
  "customer_information_order_ask": "Frage zur Bestellung",
  "customer_information_order_mandatory": "Verpflichtend machen",
  "customer_information_ticket_ask": "Frage zur Ticket",
  "customer_information_ticket_mandatory": "Verpflichtend machen",
  "customer_information_specific_question": "Frage",
  "customer_information_specific_question_type": "Art der Frage",
  "report_sold_out": "Ausverkauft",
  "back": "Zurück",
  "my_company_allowed_events_days": "Der Benutzer hat Zugang zu allen Veranstaltungen, die an den von Ihnen ausgewählten Tagen stattfinden",
  "day_mon": "Mon",
  "day_tue": "Tue",
  "day_wed": "Wed",
  "day_thu": "Thu",
  "day_fri": "Fri",
  "day_sat": "Sat",
  "day_sun": "Sun",
  "company_paynl_account_type": "Pay.nl Kontotyp",
  "company_payout_iban": "Auszahlung IBAN-Nummer",
  "company_name_is_required": "Name ist erforderlich",
  "company_domain_is_required": "Subdomain ist erforderlich",
  "company_contact_is_required": "Kontaktperson ist erforderlich",
  "pos_url_exists": "Einige oder alle POS-URLs werden verwendet",
  "permission_event_show_minimum_age_checkbox": "Ereignis Mindestalter ankreuzen",
  "pos_age_confirmation": "Ich bestätige, dass ich und die anderen Personen, für die ich Tickets bestelle, mindestens {minimum_age} oder älter sind.",
  "event_age_confirmation_form": "Lassen Sie den Kunden ein Kontrollkästchen ankreuzen, um zu bestätigen, dass er mindestens {age} Jahre alt ist",
  "ticket_template_duplicate" : "Vorlage duplizieren",
  "ticket_template_delete_entry" : "Sind Sie sicher, dass Sie diese Ticketvorlage löschen möchten?",
  "name_is_required" : "Name ist Pflicht",
  "permission_ticket_template_duplicate": "Ticketvorlage duplizieren",
  "default_account_setup": "Standard-Kontoeinrichtung",
  "backend_title_default_company_layout": "Standard-Firmenlayout",
  "backend_title_default_company_fees": "Standardgebühren",
  "backend_title_default_company_permissions": "Standardberechtigungen",
  "backend_title_default_ticket_template": "Standard-Ticketvorlage",
  "default_company_layout": "Standard-Firmenlayout",
  "default_company_fees": "Standardgebühren",
  "default_company_permissions": "Standardberechtigungen",
  "default_company_ticket_template": "Standard-Ticketvorlage",
  "permission_master_data_default_values_permissions_edit": "Standardberechtigungen bearbeiten",
  "permission_master_data_default_values_permissions_view": "Standard-Berechtigungsansicht",
  "permission_master_data_default_values_view": "Ansicht Standardwerte",
  "permission_master_data_default_values_layout_edit": "Bearbeiten des Standard-Firmenlayouts",
  "permission_master_data_default_values_layout_view": "Standard-Firmenlayoutansicht",
  "permission_master_data_default_values_fees_edit": "Standardunternehmensgebühren bearbeiten",
  "permission_master_data_default_values_fees_view": "Standardansicht der Unternehmensgebühren",
  "permission_master_data_default_values_ticket_template_view": "Standardansicht Ticketvorlage",
  "permission_master_data_default_values_ticket_template_edit": "Standard-Ticketvorlage bearbeiten",
  "field_is_required": "Feld ist erforderlich",
  "password_mismatch": "Die Passwörter stimmen nicht überein",
  "user_already_exists": "Der Benutzer ist bereits vorhanden",
  "signup_create_account": "Konto erstellen",
  "signup_enter_details": "Das Anlegen des Kontos ist völlig kostenlos!",
  "signup_chamber_of_commerce": "HRB nummer",
  "signup_iban": "IBAN",
  "signup_iban_holder_name": "Name des IBAN-Kontoinhabers",
  "signup_confirm_password": "Bestätige das Passwort",
  "signup_terms": "Ich stimme den <a target='_blank' href='https://fairtix.io/de/terms-conditions'>Allgemeinen Geschäftsbedingungen</a> zu und erkläre, dass ich befugt bin, im Namen der angegebenen Organisation zu unterzeichnen",
  "signup_already_user": "Sie haben bereits ein Konto?",
  "signup_loading_creating_account": "Account erstellen...",
  "signup_loading_configuring_the_layout": "Layout konfigurieren...",
  "signup_loading_almost_done": "Fast fertig...",
  "signup_loading_go_to_dashboard": "Gehen Sie als angemeldeter Benutzer zum Dashboard",
  "default_template_text": "Standardvorlage",
  "signup_step_2_title": "Vervollständigen Sie das Konto",
  "signup_step_2_enter_details": "Geben Sie die letzten Details an",
  "edit_ticket_template_err_no_jpg": "Das gewählte Bild muss im JPG-Format sein.",
  "edit_ticket_template_err_no_textbox": "Es muss mindestens ein Textfeld vorhanden sein.",
  "error_background": "Bild ist obligatorisch",
  "event_description_location": "Wo wollen Sie die Beschreibung anzeigen?",
  "manage_event_desc_location_top": "Oben auf der Seite",
  "manage_event_desc_location_bot": "Am Ende der Seite",
  "event_show_image_in_pos": "Bild auf der Verkaufsseite anzeigen",
  "product_scan_color": "Scanfarbe außer Kraft setzen",
  "product_scan_color_explenation": "Wenn hier eine Farbe eingestellt ist, wird diese angezeigt, sobald das Ticket erfolgreich gescannt wurde.",
  "product_remove_scan_color": "Scanfarbe entfernen",
  "pos_no_products_and_pm_are_configured": "Es sind keine Produkte und Zahlungsmethoden konfiguriert",
  "pos_no_products_are_configured": "Es sind keine Produkte konfiguriert",
  "pos_no_pm_are_configured": "Es sind keine Zahlungsarten konfiguriert",
  "event_marketing_updated": "Veranstaltungsmarketing aktualisiert",
  "permission_event_marketing_view": "Event-Marketing-Ansicht",
  "permission_event_marketing_edit": "Event-Marketing bearbeiten",
  "event_marketing_gtm_id": "Google Tag Manager-ID",
  "event_marketing_gtm_id_tooltip": "Sobald die GTM-ID eingegeben ist, wird GTM auf der Verkaufsseite aktiviert. Leeren Sie dieses Feld, um es wieder zu deaktivieren.",
  "edit_ticket_template_err_textbox_field": "Alle Textfelder sind Pflichtfelder",
  "discountcode_times_used": "Mal benutzt",
  "nav_campaigns": "Kampagnen",
  "campaign_create": "Kampagne erstellen",
  "campaign_modal_create": "Erstellen Sie eine neue Kampagne",
  "campaign_name": "Name der Kampagne",
  "campaign": "Kampagne",
  "slug": "Schlagwort",
  "event_day_selector": "Ereignis/Tag-Auswahl",
  "campaign_discount_rules": "Rabatt-Regeln",
  "campaign_discount_type": "Rabatt-Typ",
  "campaign_discount_value": "Rabatt-Wert",
  "campaign_new_discount_rule": "Neue Rabattregel",
  "campaign_reference": "Referenz",
  "campaign_when_does_this_discount_apply": "Wann gilt dieser Rabatt",
  "campaign_timeframe_from": "Zeitrahmen von",
  "campaign_timeframe_to": "Zeitraum bis",
  "reference_is_required": "Referenz ist erforderlich",
  "campaign_edit_rule": "Regel bearbeiten",
  "campaign_rule_set_product_price": "Preis des Produkts",
  "campaign_rule_set_product_name": "Name des Produkts",
  "campaign_updated": "Kampagne erfolgreich aktualisiert",
  "slug_is_required": "Slug ist erforderlich",
  "campaign_company_url": "URL der Unternehmenskampagne",
  "campaign_deleted": "Kampagne erfolgreich gelöscht",
  "cannot_delete_campaign": "Kampagne kann nicht gelöscht werden, da sie mit Aufträgen verknüpft ist",
  "campaign_times_used": "Verwendete Zeiten",
  "campaign_total_revenue": "Gesamtumsatz",
  "slug_already_used": "Slug bereits im Einsatz",
  "copied_to_clipboard": "In die Zwischenablage kopiert!",
  "order_overview_remove_discountcode_filter": "Rabattcode-Filter entfernen",
  "discountcode_overview_show_orders": "Aufträge anzeigen",
  "discountcode_tickets_times_used": "Anzahl der Tickets",
  "report_age_avg": "Durchschnittliches Alter",
  "pos_countdown": "Countdown-Uhr anzeigen",
  "pos_countdown_datetime": "Bis wann soll die Uhr herunterzählen",
  "dashboard_modal_active_carts": "Aktive Wagen",
  "layout_countdown": "Countdown-Uhr",
  "layout_countdown_card_top": "Oberste Karte Uhr",
  "layout_countdown_card_bottom": "Untere Karte Uhr",
  "layout_countdown_card_text": "Textfarbe Ziffern",
  "permission_campaigns_view": "Kampagnen-Ansicht",
  "permission_campaigns_create": "Kampagnen hinzufügen",
  "permission_campaigns_edit": "Kampagnen bearbeiten",
  "permission_campaigns_delete": "Kampagnen löschen",
  "discountcode_allowed_events": "Erlaubte Ereignisse",
  "discountcode_allowed_products": "Erlaubte Produkte",
  "order_discountcode": "Rabattcode",
  "nav_batches": "QR-code Charge",
  "batch_name": "Name der Charge",
  "ticket_name": "Ticket Name",
  "ticket_price": "Ticketpreis",
  "ticket_vat": "Ticket Vat",
  "tickets_count": "Wie viele QR-Codes möchten Sie erstellen?",
  "starts_at": "Beginnt bei",
  "ends_at": "Endet am",
  "batch_events_or_days": "Wählen Sie die Ereignisse oder Tage, an denen die Charge gültig ist",
  "edit_batch_title": "QR-Batch bearbeiten",
  "create_batch": "QR-Batch erstellen",
  "batch_created": "QR-Batch erstellt",
  "batch_updated": "QR-Batch aktualisiert",
  "batch_modal_create": "Neue Charge erstellen",
  "ticket_name_is_required": "Ticketname ist erforderlich",
  "ticket_price_is_required": "Ticketpreis ist erforderlich",
  "ticket_vat_is_required": "Ticket MwSt. erforderlich",
  "tickets_count_err": "Die Anzahl der QR-Codes muss größer als 0 und kleiner als 5000 sein",
  "batch_generate": "QR-Batch generieren",
  "batch_download": "QR-Batch herunterladen",
  "batch_generated": "Die QR-Codes werden gerade erstellt, dies kann eine Weile dauern",
  "batch_already_generated": "Die QR-Batch wurde bereits erstellt",
  "order_overview_batch_ticket": "Stapelkarte",
  "download": "Herunterladen",
  "qr_code": "QR code",
  "pos_qr_description": "Dieser QR-Code ist mit dem Point of Sale verbunden. Er kann auf Ihrem Flyer oder für andere Marketingzwecke verwendet werden",
  "campaign_highlight_discount": "Hervorhebung der Produkte mit Rabatten",
  "campaign_highlight_discount_border_color": "Farbe der Umrandung",
  "campaign_highlight_discount_background_color": "Hintergrundfarbe",
  "campaign_hide_products": "Ich möchte einige bestimmte Produkte auf der Verkaufsseite ausblenden",
  "campaign_when_hide_products": "Blenden Sie die Produkte aus, wenn:",
  "different": "Anders",
  "event_vat_is_required": "MwSt. ist erforderlich",
  "password_validation_8_chars": "Das Passwort sollte mindestens 8 Zeichen lang sein.",
  "password_validation_lowercase": "Das Passwort muss mindestens einen Kleinbuchstaben enthalten",
  "password_validation_capital": "Passwort sollte mindestens einen Großbuchstaben enthalten",
  "password_validation_number": "Passwort sollte mindestens eine Zahl enthalten",
  "signup_confirm_account": "Bestätigen Sie Ihre Daten",
  "signup_password_strength": "Das Passwort sollte 8 Zeichen lang sein und mindestens 1 Zahl, 1 Buchstabe, 1 Großbuchstabe und 1 Sonderzeichen enthalten.",
  "discountcode_apply_type": "Wie möchten Sie den Rabatt berechnen?",
  "discountcode_apply_type_order": "Pro Bestellung",
  "discountcode_apply_type_ticket": "Pro Ticket",
  "campaign_qr_description": "Dieser QR-Code ist mit der Kampagne verknüpft. Er kann für einen Flyer verwendet werden oder der QR-Code kann auf jede andere Weise verbreitet werden",
  "password_validation_special_char": "Das Passwort sollte mindestens ein Sonderzeichen enthalten",
  "export_order_timeslot": "Zeitfenster",
  "export_customer_dob": "Geburtsdatum des Kunden",
  "product_show_when_product_chosen": "Dieses Produkt nur anzeigen, wenn ein anderes Produkt ausgewählt ist",
  "event_products_selected": "Produkt(e) ausgewählt",
  "event_products_no_selected": "keine Produkte ausgewählt",
  "product_show_hide_input_fields": "Eingabefelder ein-/ausblenden",
  "product_min_max_buy_per_product": "Min. und max. Kauf pro Bestellung",
  "product_more_items": "Mehr Artikel",
  "product_image_validate_size": "Die Bildgröße sollte weniger als 4 MB betragen.",
  "product_image_validate_resolution": "Die Bildauflösung sollte weniger als 120x120 px betragen.",
  "product_sell_product_sets": "Verkaufen Sie das Produkt in Sets von",
  "master_data_auto_invoice_settings": "Einstellungen der automatischen Rechnungen",
  "auto_invoice_settings_general_stop": "Ist die automatische Rechnungsstellung aktiv?",
  "nav_auto_invoice_settings": "Einstellungen der automatischen Rechnungen",
  "changes_saved": "Gespeicherte Änderungen!",
  "error_max_buy": "Maximal pro Bestellung ist obligatorisch",
  "error_min_buy": "Mindestbestellwert ist obligatorisch",
  "product_price_inclusive_vat": "Preis (inkl. MwSt.)",
  "product_image_tooltip": "Das Bild sollte weniger als 4 MB groß sein, eine maximale Auflösung von 120x120 PX haben und entweder im PNG- oder JPEG-Format vorliegen",
  "product_send_additional_ticket": "Ein zusätzliches Ticket ausstellen",
  "product_send_additional_ticket_ordered": "Ein zusätzliches Ticket versenden, wenn dieses Produkt bestellt wird",
  "product_addition_already_set": "Dieses Ticket ist bereits als zusätzliches Ticket für {product} eingestellt",
  "product_additional_ticket_description": "Wenn dieses Produkt bestellt wird, werden die unten ausgewählten Produkte automatisch in den Warenkorb gelegt",
  "event_product_send_email": "E-Mail senden, wenn dieses Produkt bestellt wird an",
  "email_is_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse an",
  "permission_product_ordered_email_confirmation": "E-Mail-Bestätigung der Produktbestellung",
  "guest_list_order_ticket_send_successfully": "Tickets wurden erfolgreich versendet",
  "guest_list_order_ticket_generated": "Die Tickets werden gerade erstellt und versendet, bitte warten Sie, bis dieser Vorgang abgeschlossen ist...",
  "pos_free_order_btn": "Weiter zur Bestellung",
  "company_invoice_overview": "Rechnung",
  "company_invoice_overview_invoice": "Rechnung",
  "company_invoice_overview_payout_summary": "Auszahlungsunterstützung",
  "invoice_number": "Rechnungsnummer",
  "all_events": "Alle Veranstaltungen",
  "company_invoice_downloads": "Downloads",
  "company_paynl_merchant_id": "Pay.nl M-code",
  "company_invoice_overview_total_payout": "Auszahlung insgesamt",
  "company_invoice_overview_clearing_ref": "Clearing-Referenz",
  "company_invoice_overview_time_period": "Zeitspanne",
  "permission_company_invoice_view": "Rechnungsübersichtsansicht",
  "permission_company_invoice_can_download": "Kann Rechnungen herunterladen",
  "point_of_sale_modal_delete": "Verkaufsstelle entfernen",
  "point_of_sale_delete_confirmation": "Sind Sie sicher, dass Sie diese Verkaufsstelle entfernen möchten?",
  "point_of_sale_has_orders": "Die Verkaufsstelle hat Aufträge, Sie können sie nicht löschen",
  "point_of_sale_has_been_deleted": "Die Verkaufsstelle wurde gelöscht",
  "permission_event_point_of_sale_delete": "Verkaufsstelle löschen",
  "campaign_overview_btn_link_generator": "Link-Generator",
  "campaign_link_modal_title": "Link-Generator",
  "campaign_campagne": "Kampagne",
  "campaign_link_modal_link_type": "Wohin möchten Sie verlinken?",
  "campaign_link_modal_event_overview": "Veranstaltungsübersicht",
  "campaign_link_modal_specific_pos": "Spezifische POS",
  "campaign_event": "Veranstaltung",
  "campaign_pos": "POS",
  "campaign_link_modal_link": "Link",
  "cart_incl_vat": "Inkl. MwSt.",
  "fairtix_location_street": "Keizersveld 99",
  "fairtix_location_zip": "5803AP",
  "fairtix_location_city": "Venray",
  "fairtix_location_country": "Die Niederlande",
  "fairtix_location_coc": "77888286",
  "fairtix_location_vat": "NL861186163B01",
  "shop_vat": "MwSt.",
  "extension_mailchimp": "Mailchimp",
  "extension_mailchimp_api_key": "API schlüssel",
  "extension_mailchimp_audience_id": "Audience schlüssel",
  "saved_successfully": "Erfolgreich gespeichert",
  "extension_mailchimp_description": "Konfigurieren Sie Ihre Mailchimp-Synchronisierung. Die E-Mail-Adresse, der Vorname und der Nachname (falls vorhanden) werden alle 60 Minuten in Stapeln an Mailchimp übertragen. Wenn Sie die Synchronisierung stoppen möchten, löschen Sie einfach den API-Schlüssel.",
  "monday": "Montag",
  "tuesday": "Dienstag",
  "wednesday": "Mittwoch",
  "thursday": "Donnerstag",
  "friday": "Freitag",
  "saturday": "Samstag",
  "sunday": "Sonntag",
  "january": "Januar",
  "february": "Februar",
  "march": "März",
  "april": "April",
  "may": "Mai",
  "june": "Juni",
  "july": "Juli",
  "august": "August",
  "september": "September",
  "october": "Oktober",
  "november": "November",
  "december": "Dezember",
  "company_show_calendar": "Kalender auf der Veranstaltungsübersichtsseite anzeigen",
  "company_calendar_sold_ratio": "Verhältnis der verkauften Tickets",
  "permission_extensions_overview_view": "Erweiterungsübersicht anzeigen",
  "permission_extension_mailchimp": "Mailchimp",
  "permission_batch_overview_view": "Batch-Übersicht anzeigen",
  "permission_batch_edit": "Batch bearbeiten",
  "permission_batch_create": "Batch erstellen",
  "permission_master_data_auto_invoice_settings_view": "Auto invoice Einstellungen anzeigen",
  "permission_master_data_auto_invoice_settings_edit": "Auto invoice Einstellungen bearbeiten",
  "cookie_banner_title": "Cookie",
  "cookie_banner_personalize": "Personalisieren Sie Ihre Präferenzen",
  "cookie_banner_preference_local": "Lokal gespeicherte Informationen",
  "cookie_banner_preference_analytics": "Analytik",
  "cookie_banner_preference_marketing": "Marketing",
  "btn_accept_all": "Alle akzeptieren",
  "btn_accept_selected": "Ausgewählte akzeptieren",
  "cookie_banner_change_preference": "Cookie-Einstellungen ändern",
  "cookie_banner_text": "Unsere Website verwendet Cookies, um Ihnen das bestmögliche Nutzererlebnis zu bieten. So können wir uns zum Beispiel merken, was Sie in Ihren Warenkorb gelegt haben. Darüber hinaus setzen wir verschiedene andere nützliche Methoden ein, um Ihre Erfahrung zu verbessern.",
  "order_overview_payment_link": "Zahlungslink",
  "guest_list_payment_link": "Zahlungslink Email",
  "guest_list_payment_link_send": "Zahlungslink gesendet",
  "venues_overview": "Veranstaltungsorte Übersicht",
  "venue_verified": "Wird überprüft",
  "venue_name": "Name des Veranstaltungsortes",
  "new_venue": "Neuer Veranstaltungsort",
  "venue_new_modal_title": "Einen neuen Veranstaltungsort erstellen",
  "venue_create_hint": "Sobald Sie Ihren Veranstaltungsort erstellt haben, können Sie detailliertere Informationen einstellen!",
  "venue_modal_edit": "Veranstaltungsort bearbeiten",
  "venue_address": "Veranstaltungsort adresse",
  "venue_zip": "Veranstaltungsort PLZ",
  "venue_active": "Aktiv",
  "venue_city": "Veranstaltungsort stadt",
  "venue_country": "Veranstaltungsort land",
  "venue_saved": "Gespeicherter ort!",
  "venue_deleted": "Veranstaltungsort gelöscht!",
  "permission_master_data_venues_overview": "Veranstaltungsorte Übersicht",
  "permission_venue_create": "Veranstaltungsort erstellen",
  "permission_venue_delete": "Veranstaltungsort löschen",
  "permission_venue_edit": "Veranstaltungsort bearbeiten",
  "permission_add_location_event_details": "Veranstaltungsort in den Veranstaltungsdetails hinzufügen",
  "event_location": "Standort",
  "venue_is_already_used": "Veranstaltungsort ist bereits belegt",
  "error_venue.name": "Name des veranstaltungsortes ist erforderlich",
  "error_venue.address": "Adresse des veranstaltungsortes ist erforderlich",
  "error_address": "Adresse des veranstaltungsortes ist erforderlich",
  "error_venue.zip": "Der Reißverschluss des veranstaltungsortes ist erforderlich",
  "error_zip": "Der Reißverschluss des veranstaltungsortes ist erforderlich",
  "error_venue.city": "Veranstaltungsort ist erforderlich",
  "error_city": "Veranstaltungsort ist erforderlich",
  "error_venue.country_code": "Land des veranstaltungsortes ist erforderlich",
  "error_country_code": "Land des veranstaltungsortes ist erforderlich",
  "edit_ticket_template_reached_limit": "Die Bildgröße sollte weniger als 300KB betragen.",
  "company_links_overview": "Links zum Unternehmen",
  "company_master_name": "Firma Master",
  "company_sub_name": "Unternehmen Sub",
  "location_id": "Standort",
  "location_name": "Standort",
  "company_link_new_modal_title": "Einen neuen Unternehmenslink erstellen",
  "company_link_modal_edit": "Unternehmenslink bearbeiten",
  "company_link_saved": "Gespeicherter Unternehmenslink!",
  "company_link_deleted": "Firmenlink gelöscht",
  "company_link_duplicate_entry": "Unternehmen Links Vervielfältigung",
  "company_link_master_sub_not_equal": "Firmenchef darf nicht Firmenuntermann sein",
  "error_company_master_id": "Firmenstamm ist erforderlich",
  "error_company_sub_id": "Ein Unternehmen ist erforderlich",
  "permission_master_data_company_links_overview": "Unternehmenslinks Übersicht",
  "permission_master_data_company_links_create": "Firmenlink erstellen",
  "permission_master_data_company_links_edit": "Unternehmenslink Bearbeiten",
  "permission_master_data_company_links_delete": "Firmenlink Löschen",
  "company_link_unallowed_parent_child_entry": "Die Untergesellschaft kann kein untergeordnetes Konto für dieses Unternehmen sein, da es bereits eine Verbindung gibt, bei der das Unternehmen ein Hauptkonto ist",
  "end_date_must_be_greater": "Enddatum muss größer sein als das Startdatum",
  "product_limit_amount_to_maximum_tickets": "Begrenzung des Anzahl auf das Maximum der anderen Tickets",
  "birth_date_must_be_past": "Das Geburtsdatum muss in der Vergangenheit liegen",
  "product_scan_till_date_time": "Scan bis",
  "url_cannot_spaces": "URL darf keine Leerzeichen enthalten",
  "event_banner_tooltip": "Dieses Bild wird auf der Desktop-Version in der Pos-Übersicht angezeigt",
  "event_banner_image": "Banner (1180x174 Pixel) (<=1MB)",
  "manage_event_remove_banner": "Banner entfernen",
  "manage_event_banner_error_res": "Die Auflösung des Bannerbildes sollte (1180x174 Pixel) sein",
  "manage_event_banner_error_size": "Die Größe des Bannerbildes sollte weniger als 1MB betragen",
  "order_number_of_products": "Anzahl der Produkte",
  "user_app_login_duration": "Maximale Anmeldezeit in der App (in Stunden)",
  "edit_user_modal_app_login_duration_error": "Die maximale Anmeldezeit in der App muss größer als 0 sein",
  "download_tickets": "Tickets herunterladen",
  "order_status_ticket_merging": "Tickets werden zusammengelegt",
  "invoice_overview_btn_generate_invoice": "Rechnung generieren",
  "invoice_overview_btn_generate_payout_summary": "Auszahlungsunterstützung generieren",
  "administration_invoice_payout_summary_generation": "Darft Auszahlungsunterstützung und Rechnung generieren",
  "invoice_overview_file_generated": "Datei generiert",
  "ticket_template_qr_code_4cm": "Der QR-Code sollte 4CM (152PX) von den Seitenrändern entfernt sein.",
  "ticket_template_qr_size": "Der QR-Code sollte nicht kleiner als 100x100 und nicht größer als 225x225 sein",
  "export_product_ticket_value": "Einmaliger Ticket-Code",
  "select": "Auswählen...",
  "permission_administration_invoice_payout_summary_generation": "Darf Auszahlungsunterstützung und Rechnung generieren",
  "ticket_lost_title": "Haben Sie Ihre Tickets verloren?",
  "ticket_lost_description": "Bitte füllen Sie die folgenden Felder aus, um Ihre Tickets zu erhalten",
  "ticket_lost_no_orders":  "Wir haben Ihre Bestellung(en) nicht gefunden, kontaktieren Sie support-AtSign-fairtix.io für weitere Informationen",
  "ticket_lost_search_tickets": "Tickets suchen",
  "ticket_lost_your_orders_description": "Alle Tickets wurden an Ihre E-Mail-Adresse gesendet. Prüfen Sie auch Ihren Spam-Ordner.",
  "wrong_email": "Ungültige E-Mail Adresse",
  "wrong_date":  "Ungültige Datum",
  "company_order_thank_you_show_events": "Veranstaltungen auf der Dankeseite anzeigen",
  "order_thank_you_btn_event_details": "JETZT BESTELLEN",
  "order_thank_you_upcoming_events": "Auch diese Veranstaltungen sollten Sie nicht verpassen!",
  "dashboard_events_ticket_sold": "verkauft",
  "dashboard_events_ticket_guest_list": "Anzahl Gästeliste",
  "dashboard_events_yesterday": "Gestern",
  "date_and_time": "Datum und Uhrzeit",
  "start_date": "Datum des Beginns",
  "end_date": "Enddatum",
  "event_modal_create": "Ereignis erstellen",
  "lang_fr": "Französisch",
  "lang_pt": "Portugiesisch",
  "pos_will_automatically_redirect": "Wir leiten Sie innerhalb von {seconds} Sekunden automatisch auf die aktive Ereignisübersicht um",
  "pos_redirect_now": "Jetzt umleiten",
  "guest_list_event_name": "Für welche Veranstaltung möchten Sie Gästelistenkarten versenden?",
  "guest_list_customer": "An wen möchten Sie die Karten verschicken?",
  "guest_list_select_products": "Wie viel möchten Sie von welchem Ticket versenden?",
  "guest_list_send_to_email": "Tickets senden an {email}",
  "guest_list_send_payment_request": "Zahlungsaufforderung senden an {email}",
  "guest_list_send_invitation_to_sign": "Senden Sie eine Einladung zum Unterzeichnen der Tickets mit Namen",
  "guest_list_select_payment": "Was möchten Sie mit der Zahlung machen?",
  "guest_list_select_payment_free": "Keine Zahlung erforderlich",
  "guest_list_select_payment_paid": "Bargeld wurde bereits bezahlt",
  "guest_list_send": "Senden Sie",
  "guest_list_choose_tickets_to_send": "Tickets zum Versenden auswählen",
  "guest_list_ticket_type": "Ticket-Typ",
  "guest_list_price": "Preis",
  "guest_list_number": "Anzahl",
  "pos_only_available_x": "Nur {amount} verfügbar",
  "ticket_template_deleted": "Ticketvorlage erfolgreich gelöscht",
  "ticket_template_cannot_deleted":"Ticketvorlage kann nicht gelöscht werden",
  "permission_ticket_template_delete": "Ticketvorlage löschen",
  "order_overview_api_order": "API",
  "guest_list_remember_event": "Ereignis für nächsten Eintrag merken",
  "order_export_generate_export": "Export generieren",
  "order_export_export": "Exportieren",
  "order_export_type": "Welche Art von Export möchten Sie erstellen?",
  "order_export_visitor_list": "Besucherliste (für bestimmte Tickets)",
  "order_export_general": "Allgemeiner Export",
  "order_export_which_event": "Für welche Veranstaltung?",
  "order_export_event": "Wählen Sie die Veranstaltung",
  "order_export_which_tickets": "Für welche Eintrittskarten?",
  "order_export_select_tickets": "Wählen Sie die Tickets",
  "order_export_selected_tickets": "{count} gewählte(s) Ticket(s)",
  "order_export_which_email": "An welche E-Mail-Adresse möchten Sie den Export senden?",
  "order_export_period": "Welcher Zeitraum?",
  "order_export_which_fields": "Welche Felder sollen im Export enthalten sein?",
  "order_export_success": "Erfolgreich angefordert",
  "order_export_success_message": "Ihr Export wurde erfolgreich angefordert und wird an {email} gesendet. Dies kann je nach Größe der Datei einige Minuten dauern.",
  "order_export_all_tickets": "Alle Tickets",
  "orders_export_make": "Exportieren",
  "export_settings_check_all": "Alle auswählen",
  "export_event_name": "Veranstaltung",
  "export_order_number": "Bestellnummer",
  "export_total_price": "Gesamtpreis",
  "export_order_payment_fee": "Zahlungsmethode Verwaltungsgebühr",
  "export_order_payment_fee_vat": "Zahlungsart Verwaltungsgebühr MwSt.",
  "export_order_payment_fee_vat_perc": "Zahlungsart Verwaltungsgebühr MwSt. %",
  "export_ticket_fee_total": "Ticket-Verwaltungsgebühr",
  "export_ticket_fee_vat": "Ticket-Verwaltungsgebühr MwSt.",
  "export_ticket_fee_vat_perc": "Ticket-Verwaltungsgebühr MwSt. %",
  "export_product_number": "Produktnummer",
  "export_product_price": "Produktpreis",
  "export_product_price_vat": "Produktpreis MwSt.",
  "export_product_price_vat_perc": "Produktpreis MwSt. %",
  "export_product_service_fee": "Produktverwaltungskosten",
  "export_product_service_fee_vat": "Produktverwaltungskosten MwSt.",
  "export_product_service_fee_vat_perc": "Produktverwaltungskosten MwSt. %",
  "export_order_payment_method": "Zahlungsweise",
  "export_customer_first_name": "Vorname des Kunden",
  "export_customer_last_name": "Nachname des Kunden",
  "export_customer_company_name": "Firmenname des Kunden",
  "export_customer_email": "E-Mail des Kunden",
  "export_customer_address": "Adresse des Kunden",
  "export_customer_zip": "Postleitzahl des Kunden",
  "export_customer_city": "Standort des Kunden",
  "export_customer_country": "Land des Kunden",
  "export_customer_gender": "Geschlecht des Kunden",
  "export_customer_optin": "Kunde optin",
  "export_customer_phone": "Telefonnummer des Kunden",
  "export_product_id": "Produkt-ID",
  "export_product_group": "Produktgruppe",
  "export_product_name": "Name des Produkts",
  "export_product_type": "Produkttyp",
  "event_product_allow_for_multiple_events": "Mehrere Ereignisse zulassen",
  "select_events": "Ereignisse auswählen",
  "event_duplicate_product_allowed_events_note": "ACHTUNG: Du musst neue Veranstaltungen nach dem Duplizieren manuell mit diesem Produkt verknüpfen.",
  "order_export_select_specific_event": "Wählen Sie ein spezifisches Veranstaltung",
  "event_product_available_amount": "Verfügbare Menge",
  "event_product_create_hint": "Sobald Sie das Ticket erstellt haben, können Sie bei Bedarf weitere Optionen einstellen.",
  "event_product_type_entrance": "Zutritt",
  "event_product_type_tokens": "Wertmarken",
  "event_product_type_parking": "Parken",
  "event_product_type_cross-sell": "Cross-Sell",
  "event_product_type_merchandise": "Handelswaren",
  "event_product_type_donation": "Spende",
  "event_product_type_other": "Andere",
  "event_product_create_success": "Produkt erfolgreich erstellt.",
  "pos_buy_your_tickets": "Kaufen Sie jetzt Ihre Tickets!",
  "pos_timeslot_choose_the_time":"Wählen Sie den Zeitpunkt Ihres Besuchs",
  "pos_personal_details": "Persönliche Daten",
  "pos_personal_details_complete_purchase":"Schließen Sie Ihren Kauf ab",
  "pos_payment": "Bezahlung",
  "pos_payment_description":"Wählen Sie eine Zahlungsmethode",
  "pos_order_success_title": "Ihre Bestellung: #{order_number} wurde erfolgreich aufgegeben!",
  "event_product_persons":"Anzahl der Personen",
  "persons": "Personen",
  "pos_place_order_total":"Total (inkl. MwSt. & €{total} Buchungskosten)",
  "pos_place_order_got_a_code": "Haben Sie einen Code?",
  "read_more": "Mehr lesen",
  "read_less": "Weniger lesen",
  "layout_accent_color": "Akzentfarbe",
  "layout_description_color": "Farbe der Beschreibung",
  "layout_buttons_color": "Farbe der Schaltfläche",
  "layout_button_text_color": "Textfarbe der Schaltfläche",
  "pos_important_information": "Wichtige Informationen",
  "shop_no_products_selected": "Keine Produkte ausgewählt",
  "pos_buy_extra_products": "Kaufe zusätzliche Produkte",
  "event_description_open_status": "Beschreibung direkt anzeigen",
  "event_manage_event_description_show_tooltip": "Wenn diese Option aktiviert ist, wird die Ereignisbeschreibung direkt auf der Ereignisseite angezeigt. Wenn sie nicht aktiviert ist, müssen die Benutzer diese Option manuell öffnen.",
  "event_products_create_first_ticket": "Erstelle dein erstes Ticket!",
  "event_products_create_ticket_hint": "Jedes großartige Event beginnt mit einem Ticket - deinem! Klicke auf den Button und erstelle dein Ticket.",
  "event_products_create_ticket_btn": "Ticket erstellen",
  "event_products_create_pos": "Erstelle deinen Verkaufsstand!",
  "event_products_create_pos_hint": "Um Tickets verkaufen zu können, benötigst du einen Verkaufsstand! Klicke auf den Button und erstelle deinen Verkaufsstand.",
  "event_products_create_pos_btn": "Verkaufsstand erstellen",
  "event_selected_products": "Produkt(e)",
  "event_products_mass_update": "Massenaktualisierung Produkt",
  "event_products_group_name": "Gruppenname",
  "event_products_capacity": "Kapazität",
  "event_product_mass_update_success": "Produkte erfolgreich aktualisiert",
  "pos_fill_in_discount_code": "Geben Sie Ihren Rabattcode ein",
  "discount_code": "Rabattcode",
  "something_went_wrong": "Etwas ist schiefgelaufen",
  "pos_use_discount_code": "Rabattcode verwenden",
  "btn_apply": "Anwenden"
}